<template>
    <div class="apparea">
        <!-- @wheel="handleWheel"-->
        <div v-if="video" class="mainUI" @click="video = !video" style="cursor:pointer;z-index:1000;" id="uiDiv" oncontextmenu="return false;">
            <div class="xbutton" style="top:20px;left:20px;position:fixed;z-index:1000;">X</div>
            <div style="width:100vw;height:100vh;position:fixed;"><iframe src="https://player.vimeo.com/video/867526170?h=5ac694b416&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:fixed;top:0;left:0;width:100%;height:100%;"
                    title="NOCLIP V4 MASTER PRORES"></iframe></div>
            <div class="regionUI">
                <div class="buttonUI">
                    <div @mousedown="video = false" id="buttonEnter">
                        <h1>ENTER</h1>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="demo-desc" v-if="modalActive">
            <div class="infobox">
                <p></p>
                <div class="button" @click="modalActive = !modalActive">I UNDERSTAND</div>
            </div>
        </div>
        <div class="perspective" style="cursor: crosshair!important;">
    
            <a-scene id="scene" vr-mode-ui="enabled: true; enterVRButton: #enterVR; enterARButton: #enterAR" loading-screen="dotsColor: #fffa; backgroundColor: black" ref="scene" reflection="directionalLight:a-light#dirlight;" :cursor=" { rayOrigin: cursor ? 'xrselect' : 'mouse'}"
                renderer="powerPreference: high-performance; antialias: true; shadowMap.enabled: true; shadowMap.type: PCFSoftShadowMap; colorManagement: true; highRefreshRate: true; toneMapping: cineon; sortObjects: true; exposure: 1; precision: high;  physicallyCorrectLights: true;  maxCanvasWidth: 4096; maxCanvasHeight: 4096;">
    
                <a-assets>
                    <img id="earthNightMap" src="8k_earth_nightmap.jpg">
                    <img id="earthDayMap" src="8k_earth_daymap.jpg">
                    <img id="stars" src="8k_stars_milky_way.jpg">
                    <a-asset-item id="optimerBoldFont" src="Line_UltraLight.json"></a-asset-item>
                </a-assets>
                <a-sky color="#111"></a-sky>
    
    
                <a-entity v-if="intro >= 1" :position="cameraPosition">
    
                    <a-camera :cursor="{rayOrigin: 'mouse', fuse: 'true', fuseTimeout: '100'}" active="true" smooth-camera="easing: 0.5" smooth-follow-mouse="easing: 0.1; maxAngle: 20" rotation-reader rotation="0 0 0" id="camera" :fov="this.fov" reverseMouseDrag="true" look-controls="false"
                        wasd-controls-enabled="false" ref="camera">
                        <!--smooth-camera="easing: 0.5" smooth-follow-mouse="easing: 0.1; maxAngle: 20" -->
    
    
                        <a-entity v-if="intro >= 1 && isDesktop()">
    
                            <a-light light="type: ambient;" intensity="2" position="0 0 200" color="#ffffff">
                            </a-light>
    
                            <a-entity v-if="intro == 1" id="nocliptext" rotation="0 0 0" material="color: #fffa;" position="-1.2 0 -3">
                                <a-entity v-if="intro == 1" text-geometry="value: NOCLIP; bevelThickness: 5; font: #optimerBoldFont; height: 0.01; size: 0.45;" rotation="0 0 0" material="color: #fffa;" position="-0.02 0.6 0"> </a-entity>
                                <a-entity v-if="intro == 1" text-geometry="value: OVERVIEW EFFECT FOR EVERYONE; bevelThickness: 5; font: #optimerBoldFont; height: 0.01; size: 0.09;" rotation="0 0 0" material="color: #ffffff;" position="0 0.4 0"> </a-entity>
                                <a-entity>
                                    <a-entity line="start: 0 0.25 0; end: 2 0.25 0; color: #ffffff" position="0 0 0" rotation="0 0 0"></a-entity>
                                    <a-entity line="start: 0 -0.25 0; end: 2 -0.25 0; color: #ffffff" position="0 0 0" rotation="0 0 0"></a-entity>
                                </a-entity>
    
                                <a-entity position="0.8 0.05 -1" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:9000; ">
                                    <a-entity rotation="0 0 0" animation="property: rotation; to: 0 0 720 ; easing: easeInQuad; loop: true; dir: alternate; dur:6000; ">
                                        <arc-entity :thickness="0.01" :diameter="5" :degrees="45" :angle="22.5" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#ffffff"></arc-entity>
                                        <arc-entity :thickness="0.01" :diameter="5" :degrees="45" :angle="202.5" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#ffffff"></arc-entity>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:20000; ">
                                        <arc-entity :thickness="0.01" :diameter="4.5" :degrees="90" :angle="45" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 -720 ; easing: linear; loop: true; dir: forward; dur:10000; ">
                                        <arc-entity-deg :thickness="0.05" animation="property: degrees; to: 10 ; easing: easeInQuad; loop: true; dir: alternate; dur:10000;" :diameter="6" :degrees="300" :angle="270" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="white"></arc-entity-deg>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0">
                                        <arc-entity :segments="30" :breakAngle="5" :thickness="0.01" animation="property: segments; to: 10 ; easing: easeInQuad; loop: true; dir: alternate; dur:10000;" :diameter="5.25" :degrees="300" :angle="270" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:5000; ">
                                        <a-sphere radius="0.01" position="0 1.5 0">
                                        </a-sphere>
                                    </a-entity>
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 -360 ; easing: linear; loop: true; dir: forward; dur:8000; ">
                                        <a-sphere radius="0.01" position="0 2 0">
                                        </a-sphere>
                                    </a-entity>
                                </a-entity>
    
    
                                <a-entity position="1.2 0.2 0" animation="property: rotation; to: 0 5 0 ; easing: linear; loop: true; dir: forward; dur:2000; ">
                                    <a-light light="type: directional; angle: 120; castShadow:true;" intensity="3" target="#nocliptext" position="1 0 2" color="#ffffff">
                                    </a-light>
                                </a-entity>
    
    
                                <a-entity backgroundColor="transparent" borderColor="transparent" image="" title="" href="https://noclip.org" @click="goToURL('https://noclip.org')" @mouseenter="playChirp(4000, 0.0, 0.1)" @mouseup="playChirp(2000, 0.1, 0.2)" position="0.6 0.01 0.5">
    
                                    <a-rounded color="#ffffff" radius="0.05" position=" -0.4 -0.12" width="0.8" height="0.2" opacity="0.5">
                                    </a-rounded>
    
                                    <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position=" 0 0 0 " value="GET NOCLIP">
                                    </a-text>
                                </a-entity>
    
    
                                <a-entity backgroundColor="transparent" borderColor="transparent" image="" title="" href="" @click="goToURL('https://demo.noclip.org')" @mouseenter="playChirp(4000, 0.0, 0.1)" position="1.47 0.01 0.5">
    
                                    <a-rounded color="#e7b648" radius="0.05" position=" -0.4 -0.12 " width="0.8" height="0.2" opacity="0.5">
                                    </a-rounded>
    
                                    <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position="0 0 0 " value="OLD DEMO">
                                    </a-text>
                                </a-entity>
    
                                <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @click="enableLookControls()" @mousedown="this.intro = 0, this.efficient = false,  this.timescale = 1 " @mouseup="playChirp(2000, 0.1, 0.2)" position="0.6 -0.4 0.5">
    
                                    <a-rounded color="#ffffff" radius="0.05" position=" -0.4 -0.12" width="0.8" height="0.2" opacity="0.5">
                                    </a-rounded>
    
                                    <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position=" 0 0 0 " value="CONNECT">
                                    </a-text>
                                </a-entity>
                                <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @mousedown="this.intro = 2, this.efficient = true,  this.timescale = 1, this.startOverviewEffect({x: 20, y: -5, z: 5}, {x: -30, y: 20, z: -90}, 2000); " @mouseup="playChirp(2000, 0.1, 0.2)" position="1.47 -0.4 0.5">
    
                                    <a-rounded color="#e7b648" radius="0.05" position=" -0.4 -0.12 " width="0.8" height="0.2" opacity="0.5">
                                    </a-rounded>
    
                                    <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position="0 0 0 " value="MANUAL">
                                    </a-text>
                                </a-entity>
    
    
                            </a-entity>
    
    
                            <a-entity v-if="intro == 2" id="nocliptext" animation="property: rotation; to: 0 -10 0; easing: easeInQuad; loop: true; dir: alternate; dur: 10000;" rotation="0 -15 0" material="color: #ffffff;" text-geometry="value: EVERYONE; bevelThickness: 5; font: #optimerBoldFont; height: 0.01;"
                                position="0.25 2 -5">
    
                                <a-entity id="nocliptext" rotation="0 0 0" material="color: #ffffff;" text-geometry="value: EVERYWHERE; bevelThickness: 5; size: 0.39; font: #optimerBoldFont;  height: 0.01;" position="0 -1 0">
                                </a-entity>
                                <a-entity id="nocliptext" rotation="0 0 0" material="color: #ffffff;" text-geometry="value: GETS ACCESS; bevelThickness: 5; size: 0.39; font: #optimerBoldFont;  height: 0.01;" position="0 -0.5 0">
                                </a-entity>
    
                                <a-entity position="1.2 0.2 0" animation="property: rotation; to: 0 5 0 ; easing: linear; loop: true; dir: alternate; dur:2000; ">
                                    <a-light light="type: directional; angle: 120; castShadow:true;" intensity="3" target="#nocliptext" position="1 0 2" color="#ffffff">
                                    </a-light>
                                </a-entity>
    
                                <a-entity position="1.2 0.2 0" rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:5000; ">
                                    <a-sphere radius="0.01" position="0 1.5 0">
                                    </a-sphere>
                                </a-entity>
    
                                <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @mousedown="this.intro = 3, this.timescale = 1, this.efficient = false, this.startOverviewEffect({x: 0, y: 1.6, z: 10}, {x: 0, y: 0, z: 360}, 2000);" @mouseup="playChirp(2000, 0.1, 0.2)" position="1.05 -1.5 0.1">
    
                                    <a-rounded radius="0.1" position=" -1 -0.22 " width="2" height="0.4" opacity="1" color="eaff96">
                                    </a-rounded>
                                    <a-text font="exo2semibold" negate="false" color="black" align="center" width="4" value="THE OVERLAY GRID">
                                    </a-text>
                                </a-entity>
                            </a-entity>
    
                            <a-entity v-if="intro == 3" id="nocliptext" rotation="0 0 0" material="color: #ffffff;" position="0 0 -2">
                                <a-entity geometry="primitive: ring; radiusInner: 2; radiusOuter: 2.01;segmentsTheta: 64;" material="color: #fffa; shader: flat" position=" 0 0 -1">
    
                                    <a-entity rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:10000; ">
                                        <arc-entity :segments="3" :segmentsto="3" :breakAngle="60" :thickness="0.1" :diameter="3.5" :degrees="360" :angle="0" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>
                                    </a-entity>
                                </a-entity>
                                <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @mousedown=" this.timescale = 1, enableLookControls(),  this.efficient = false, this.startOverviewEffect({x: 0, y: 0, z: 0}, {x: 0, y: 0, z: 0}, 2000)" @mouseup="playChirp(2000, 0.1, 0.2), this.intro = 0"
                                    position="0 0 0.1">
    
                                    <a-circle segments="64" color="#ffffff" opacity="0.5" radius="1"></a-circle>
    
                                    <a-text font="exo2semibold" negate="false" color="black" align="center" width="4" value="ENTER STREAM">
                                    </a-text>
                                </a-entity>
                            </a-entity>
    
    
                        </a-entity>
    
                        <a-entity v-if="intro >= 1 && isMobile()">
    
    
    
                            <a-light light="type: ambient;" intensity="2" position="0 0 200" color="#ffffff">
                            </a-light>
    
                            <a-entity v-if="intro == 1" id="nocliptext" rotation="0 0 0" material="color: #fffa;" position="-1.05 0 -3.5">
                                <a-entity v-if="intro == 1" text-geometry="value: NOCLIP; bevelThickness: 5; font: #optimerBoldFont; height: 0.01; size: 0.45;" rotation="0 0 0" material="color: #fffa;" position="-0.02 0.6 0"> </a-entity>
                                <a-entity v-if="intro == 1" text-geometry="value: OVERVIEW EFFECT FOR EVERYONE; bevelThickness: 5; font: #optimerBoldFont; height: 0.01; size: 0.09;" rotation="0 0 0" material="color: #ffffff;" position="0 0.4 0"> </a-entity>
                                <a-entity>
                                    <a-entity line="start: 0 0.25 0; end: 2 0.25 0; color: #ffffff" position="0 0 0" rotation="0 0 0"></a-entity>
                                    <a-entity line="start: 0 -0.25 0; end: 2 -0.25 0; color: #ffffff" position="0 0 0" rotation="0 0 0"></a-entity>
                                </a-entity>
    
                                <a-entity position="1 0.05 -1" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:9000; ">
                                    <a-entity rotation="0 0 0" animation="property: rotation; to: 0 0 720 ; easing: easeInQuad; loop: true; dir: alternate; dur:6000; ">
                                        <arc-entity :thickness="0.01" :diameter="5" :degrees="45" :angle="22.5" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#ffffff"></arc-entity>
                                        <arc-entity :thickness="0.01" :diameter="5" :degrees="45" :angle="202.5" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#ffffff"></arc-entity>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:20000; ">
                                        <arc-entity :thickness="0.01" :diameter="4.5" :degrees="90" :angle="45" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 -720 ; easing: linear; loop: true; dir: forward; dur:10000; ">
                                        <arc-entity-deg :thickness="0.05" animation="property: degrees; to: 10 ; easing: easeInQuad; loop: true; dir: alternate; dur:10000;" :diameter="6" :degrees="300" :angle="270" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="white"></arc-entity-deg>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0">
                                        <arc-entity :segments="30" :breakAngle="5" :thickness="0.01" animation="property: segments; to: 10 ; easing: easeInQuad; loop: true; dir: alternate; dur:10000;" :diameter="5.25" :degrees="300" :angle="270" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>
                                    </a-entity>
    
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:5000; ">
                                        <a-sphere radius="0.01" position="0 1.5 0">
                                        </a-sphere>
                                    </a-entity>
                                    <a-entity position="0 0 -0.5" rotation="0 0 0" animation="property: rotation; to: 0 0 -360 ; easing: linear; loop: true; dir: forward; dur:8000; ">
                                        <a-sphere radius="0.01" position="0 2 0">
                                        </a-sphere>
                                    </a-entity>
                                </a-entity>
    
    
                                <a-entity position="1.2 0.2 0" animation="property: rotation; to: 0 5 0 ; easing: linear; loop: true; dir: forward; dur:2000; ">
                                    <a-light light="type: directional; angle: 120; castShadow:true;" intensity="3" target="#nocliptext" position="1 0 2" color="#ffffff">
                                    </a-light>
                                </a-entity>
    
                                <a-entity position="-0.04 0 0.12">
    
    
                                    <a-entity backgroundColor="transparent" borderColor="transparent" image="" title="" href="https://noclip.org" @click="goToURL('https://noclip.org')" @mouseenter="playChirp(4000, 0.0, 0.1)" @mouseup="playChirp(2000, 0.1, 0.2)" position="0.6 0.01 0.5">
    
                                        <a-rounded color="#ffffff" radius="0.05" position=" -0.4 -0.12" width="0.8" height="0.2" opacity="0.5">
                                        </a-rounded>
    
                                        <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position=" 0 0 0 " value="GET NOCLIP">
                                        </a-text>
                                    </a-entity>
    
    
                                    <a-entity backgroundColor="transparent" borderColor="transparent" image="" title="" href="" @click="goToURL('https://demo.noclip.org')" @mouseenter="playChirp(4000, 0.0, 0.1)" position="1.47 0.01 0.5">
    
                                        <a-rounded color="#e7b648" radius="0.05" position=" -0.4 -0.12 " width="0.8" height="0.2" opacity="0.5">
                                        </a-rounded>
    
                                        <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position="0 0 0 " value="OLD DEMO">
                                        </a-text>
                                    </a-entity>
    
                                    <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @click="enableLookControls()" @mousedown="this.intro = 0, this.efficient = false,  this.timescale = 1 " @mouseup="playChirp(2000, 0.1, 0.2)" position="0.6 -0.4 0.5">
    
                                        <a-rounded color="#ffffff" radius="0.05" position=" -0.4 -0.12" width="0.8" height="0.2" opacity="0.5">
                                        </a-rounded>
    
                                        <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position=" 0 0 0 " value="CONNECT">
                                        </a-text>
                                    </a-entity>
                                    <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @mousedown="this.intro = 2, this.efficient = true,  this.timescale = 1, this.startOverviewEffect({x: 20, y: -5, z: 5}, {x: -30, y: 20, z: -90}, 2000); " @mouseup="playChirp(2000, 0.1, 0.2)" position="1.47 -0.4 0.5">
    
                                        <a-rounded color="#e7b648" radius="0.05" position=" -0.4 -0.12 " width="0.8" height="0.2" opacity="0.5">
                                        </a-rounded>
    
                                        <a-text font="exo2semibold" negate="false" color="black" align="center" width="3" position="0 0 0 " value="MANUAL">
                                        </a-text>
                                    </a-entity>
                                </a-entity>
    
    
    
                            </a-entity>
                            <a-entity v-if="intro == 2" id="nocliptext" animation="property: rotation; to: 10 0 0; easing: easeInQuad; loop: true; dir: alternate; dur: 10000;" rotation="-10 0 0" material="color: #ffffff;" text-geometry="value: EVERYONE; bevelThickness: 5; font: #optimerBoldFont; height: 0.01;"
                                position="-1.75 2.5 -5">
                                <a-entity id="nocliptext" rotation="0 0 0" material="color: #ffffff;" text-geometry="value: EVERYWHERE; bevelThickness: 5; size: 0.39; font: #optimerBoldFont;  height: 0.01;" position="0 -0.6 0">
                                </a-entity>
    
                                <a-entity position="1.2 0.2 0" animation="property: rotation; to: 0 5 0 ; easing: linear; loop: true; dir: alternate; dur:2000; ">
                                    <a-light light="type: directional; angle: 120; castShadow:true;" intensity="3" target="#nocliptext" position="1 0 2" color="#ffffff">
                                    </a-light>
                                </a-entity>
    
                                <a-entity position="1.2 0.2 0" rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:5000; ">
                                    <a-sphere radius="0.01" position="0 1.5 0">
                                    </a-sphere>
                                </a-entity>
    
                                <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @mousedown=" this.timescale = 1, this.efficient = false, this.startOverviewEffect({x: 0, y: 0, z: 20}, {x: 0, y: 0, z: 0}, 2000);" @mouseup="playChirp(2000, 0.1, 0.2), this.intro = 3" position="1.1 -1.2 0.2">
    
                                    <a-rounded radius="0.1" position=" -1 -0.25 " width="2" height="0.5" opacity="1">
                                    </a-rounded>
    
                                    <a-text font="exo2semibold" color="black" align="center" width="4" value="THE OVERLAY GRID">
                                    </a-text>
                                </a-entity>
                            </a-entity>
                            <a-entity v-if="intro == 3" id="nocliptext" rotation="0 0 0" material="color: #ffffff;" position="0 0 -2">
                                <a-entity geometry="primitive: ring; radiusInner: 2; radiusOuter: 2.01;segmentsTheta: 64;" material="color: #fffa; shader: flat" position=" 0 0 -2">
    
                                    <a-entity rotation="0 0 0" animation="property: rotation; to: 0 0 360 ; easing: linear; loop: true; dir: forward; dur:10000; ">
                                        <arc-entity :segments="3" :segmentsto="3" :breakAngle="60" :thickness="0.1" :diameter="3.5" :degrees="360" :angle="0" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>
                                    </a-entity>
                                </a-entity>
                                <a-entity @mouseenter="playChirp(4000, 0.1, 0.1)" @mousedown=" this.timescale = 1, enableLookControls(),  this.efficient = false, this.startOverviewEffect({x: 0, y: 0, z: 0}, {x: 0, y: 0, z: 0}, 2000)" @mouseup="playChirp(2000, 0.1, 0.2), this.intro = 0"
                                    position="0 0 0">
    
                                    <a-rounded radius="0.1" position=" -0.75 -0.25 " width="1.5" height="0.5" color="eaff96" opacity="1">
                                    </a-rounded>
    
                                    <a-text font="exo2semibold" color="black" align="center" width="4" position="0 0.025 0" value="ENTER STREAM">
                                    </a-text>
                                </a-entity>
                            </a-entity>
    
                        </a-entity>
                    </a-camera>
                </a-entity>
    
    
                <a-entity v-if="intro == 0" :position="cameraPosition">
    
                    <a-camera :cursor="{rayOrigin: 'mouse', fuse: 'true', fuseTimeout: '100'}" smooth-camera="easing: 0.5" smooth-follow-mouse="easing: 0.1; maxAngle: 20" active="true" rotation-reader rotation="0 0 0" id="camera" :fov="this.fov" reverseMouseDrag="true" look-controls
                        wasd-controls-enabled="false" ref="camera">
    
    
                        <a-entity :position="`0 0 ${this.zPosition}`">
    
    
    
                            <a-entity v-if="cursor && hud >= 1" ref="cursor" id="cursor" raycaster-thresholds="line: 0.1; points: 0.1" :cursor="{
                                                                                                    rayOrigin: 'mouse', 
                                                                                                    fuse: 'true', 
                                                                                                    fuseTimeout: '100'
                                                                                                    }" geometry="primitive: ring; radiusInner: 0.02; radiusOuter: 0.028" material="color: #fffa; shader: flat" :rotation="this.cursorRotation" position=" 0 0 -3">
    
                                <a-entity geometry="primitive: ring; radiusInner: 0.2; radiusOuter: 0.21" material="color: #fffa; shader: flat" :rotation="this.cursorRotation" position=" 0 0 -1">
                                    <a-entity line="start: 0.03 0 0; end: 0.08 0 0.1; color: #ffffff" position="0 0 2" rotation="0 0 -30"></a-entity>
                                    <a-entity line="start: -0.03 0 0; end: -0.08 0 0.1; color: #ffffff" position="0 0 2" rotation="0 0 30"></a-entity>
                                    <a-entity line="start: 0 0.03 0 ; end:  0 0.08 0.1; color: #ffffff" position="0 0 2"></a-entity>
                                    <a-entity :rotation="topDialRotationInv">
                                        <!-- <arc-entity :segments="3" :segmentsto="3" :breakAngle="60" :thickness="0.005" :diameter="0.5" :degrees="360" :angle="0" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#e7b648"></arc-entity>-->
                                    </a-entity>
                                </a-entity>
                            </a-entity>
    
                            <a-entity v-if="hud >= 2" width="0.5" position="0 0.125 0">
                                <a-entity rotation="0 0 0" position="0 4.2 -2">
                                    <!--<a-circle segments="32" color="#000000" opacity="0.2" radius="3.9"></a-circle>-->
    
                                    <arc-entity :segments="1" :segmentsto="1" :breakAngle="0" :thickness="0.002" :diameter="6" :degrees="360" :angle="0" :rotation="[0, 0, 0]" :position="[0, 0, 0]" opacity="0.5" color="#ffffff"></arc-entity>
    
                                    <a-entity id="dial" :rotation="topDialRotation">
                                        <a-circle id="dialknob" segments="10" color="#e7b648" opacity="1" radius="0.04" :rotation="topDialRotationInv" position="0 -3.007 0.01" @mousedown="topDialOnMouseDown" @mousemove="topDialOnMouseMove" @mouseup="topDialOnMouseUp">
                                            <!--  <a-entity line="start: 0 0 0; end: 0 -0.1 0; color: #ffffff" position="0 0 0">
                                                                                                                <a-circle id="dialknob" segments="3" color="#ffffff" opacity="1" radius="0.001" position="0 -0.1 0" :rotation="topDialRotation">
                                                                                                                    <a-entity line="start: 0 0 0; end: 0 -0.1 0; color: #ffffff" position="0 0 0">
                                                                                                                        <a-circle id="dialknob" segments="3" color="#ffffff" opacity="1" radius="0.001" position="0 -0.1 0" :rotation="topDialRotationInv">
                                                                                                                            <a-text font="exo2semibold" height="0.04" position="0 -0.05 0" align="center" width="1" color="#e7b648" :value="topDialRotationInv + ' POS ' + topDialRotation"> </a-text>
                                                                                                                        </a-circle>
                                                                
                                                                
                                                                                                                    </a-entity>
                                                                                                                </a-circle>
                                                                
                                                                
                                                                                                            </a-entity>
                                                                                                                -->
                                        </a-circle>
                                    </a-entity>
                                </a-entity>
    
                                <a-text font="exo2semibold" position="0 0.65 -1" align="center" width="0.5" color="#e7b648" :value="'TIME MULTIPLIER: ' + timescale"> </a-text>
    
    
                                <a-text font="exo2semibold" position="0 0.70 -1" align="center" width="0.5" color="#e7b648" :value="'LAT ' + parseFloat(this.latReceived).toFixed(2) + '  LON ' + parseFloat(this.lonReceived).toFixed(2)">
    
    
                                </a-text>
                                <a-text font="exo2semibold" height="0.04" position="-0.252 0.7 -1" align="center" width="0.5" color="#e7b648" :value="'NODE ' + selectedIndex + ' SELECTED'">
    
                                </a-text>
    
                                <a-entity @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="playChirp(1000, 0.1, 0.02)" @click="visitLink(linkReceived)" position="-0.252 0.75 -1">
                                    <a-rounded radius="0.015" color="#222222" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" :value="linkReceived"></a-text>
    
                                </a-entity>
    
                                <a-entity @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="playChirp(1000, 0.1, 0.02)" position="0.252 0.75 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" :value="this.titleReceived"></a-text>
                                </a-entity>
    
    
                                <a-text height="0.04" position="0.252 0.70 -1" align="center" width="0.5" color="#e7b648" :value="descReceived">
    
                                </a-text>
    
                                <a-entity v-if="selectedIndex == null" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="playChirp(1000, 0.1, 0.02)" @click="addMarker" position="0 0.75 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Add Node"></a-text>
    
    
                                </a-entity>
    
                                <a-entity v-if="selectedIndex !== null" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="playChirp(1000, 0.1, 0.02)" @click="handleMarkerRemoval(selectedIndex)" position="0 0.75 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Remove Node"></a-text>
    
                                </a-entity>
    
                                <a-entity opacity="0.5" id="enterVR" @mousedown="debugMenu = true" @mouseenter="playChirp(9000, 0.01, 0.01)" position="0 0.8025 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="ENTER VR"></a-text>
    
    
                                </a-entity>
    
    
    
                                <a-entity @click="popMap2(), playChirp(1000, 0.1, 0.02)" opacity="0.5" id="enterVR" @mouseenter="playChirp(9000, 0.01, 0.01)" position="-0.252  0.8025 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="HEATMAP"></a-text>
    
    
                                </a-entity>
    
    
                                <a-entity @click="popMap(), playChirp(1000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" position="0.252 0.8025 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="POPULATION"></a-text>
    
    
                                </a-entity>
    
                            </a-entity>
    
    
    
                            <a-entity v-if="hud >= 2" width="0.5" position="0 -0.075 0">
                                <!--   <a-entity rotation="0 0  0" position="0 -4.2 -2">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <a-entity animation="property: rotation; to: 0 0 160 ; easing: easeInQuad; loop: true; dir: alternate; dur:1000;" rotation="0 0 200" position="0 0 0">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <a-entity rotation="0 0 0" position="0 -3.1 0">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <a-entity line="start: 0 0 0 ; end:  0 0.1 0; color: #e7b648" position="0 0 0"></a-entity>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </a-entity>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            </a-entity>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <a-circle segments="32" color="#000000" opacity="0.2" radius="3.9"></a-circle>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <arc-entity :segments="160" :segmentsto="160" :breakAngle="1.5" :thickness="0.002" :diameter="6" :degrees="360" :angle="45" :rotation="[0, 0, 0]" :position="[0, 0, 0]" color="#ffffff"></arc-entity>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        </a-entity>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        -->
                                <a-entity>
                                    <a-text font="exo2semibold" position="0 -0.7 -1" align="center" width="0.5" color="#e7b648" :value="currentTime"></a-text>
                                </a-entity>
    
                                <a-entity v-if="efficient" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.efficient = false, playChirp(1000, 0.1, 0.02)" position="-0.252 -0.75 -1">
    
    
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Simulated"></a-text>
                                </a-entity>
    
                                <a-entity v-if="!efficient" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.efficient = true, playChirp(1000, 0.1, 0.02)" position="-0.252 -0.75 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Land Grid"></a-text>
                                </a-entity>
    
                                <a-entity @mousedown="cursor = false, playChirp(1000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" position="0 -0.75 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" :color="cursor ? 'white' : '#e7b648'" align="center" width="0.5" :value="cursor ? 'Open Keyboard' : 'Down Arrow Closes'"></a-text>
                                </a-entity>
    
                                <a-entity @mousedown="progs(), playChirp(1000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" position="0.252 -0.75 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" v-if="prog == 1" color="white" align="center" width="0.5" :value="'Title: ' + this.keyboardOutputTitle"></a-text>
                                    <a-text font="exo2semibold" v-if="prog == 2" color="#e7b648" align="center" width="0.5" :value="'Desc: ' + this.keyboardOutputDesc"></a-text>
                                    <a-text font="exo2semibold" v-if="prog == 3" color="#ff6600" align="center" width="0.5" :value="'Link: ' + this.keyboardOutputLink"></a-text>
                                </a-entity>
    
    
    
                                <a-entity v-if='wallet.address == ""' @click="connectWallet" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.efficient = true, playChirp(1000, 0.1, 0.02)" position="-0.252 -0.802 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Connect Wallet"></a-text>
                                </a-entity>
    
    
                                <a-entity v-if='wallet.address != "" && this.loading == false && noclipBalance > 0' @click="overlaySelect = !overlaySelect" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.efficient = true, playChirp(1000, 0.1, 0.02)" position="-0.252 -0.802 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Overlay Select"></a-text>
                                </a-entity>
    
                                <a-entity v-if='wallet.address != "" && this.loading == false && noclipBalance == 0' @mousedown="this.hud = 1, this.stream = false, playChirp(1000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" position="-0.252 -0.802 -1">
                                    <a-rounded color="#222222" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="Buy Noclip"></a-text>
                                </a-entity>
    
    
                                <a-entity v-if='wallet.address == ""' @click="connectWallet" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.efficient = true, playChirp(1000, 0.1, 0.02)" position="0 -0.802 -1">
                                    <a-rounded color="indianred" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" value="CONNECT METAMASK"></a-text>
                                </a-entity>
    
                                <a-entity v-if='wallet.address != "" && this.loading == false' @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.efficient = true, playChirp(1000, 0.1, 0.02)" position="0 -0.802 -1">
                                    <a-rounded color="olive" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="white" align="center" width="0.5" :value="noclipBalance + ' NOCLIP'"></a-text>
                                </a-entity>
    
    
    
                                <a-entity @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="this.hud = 1, this.stream = false, playChirp(1000, 0.1, 0.02)" position="0.252 -0.802 -1">
                                    <a-rounded color="white" radius="0.015" position="-0.125 -0.025 0" width="0.25" height="0.05" opacity="1">
    
                                    </a-rounded>
    
    
                                    <a-text font="exo2semibold" color="black" align="center" width="0.5" value="Introduction"></a-text>
                                </a-entity>
    
    
                            </a-entity>
    
    
    
                            <a-entity v-if="hud >= 1" @mousedown="playChirp(2000, 0.1, 0.02)" id="leftstack" width="1" line-stack :position="calculateLeftComplication()">
                                <a-entity class="ignored" connecting-line__2="start:#leftstack;startOffset: 0 0 0 ;end:#leftcomp;endOffset: 0 0 0 ; color:#e7b648">
                                </a-entity>
                                <a-entity id="leftcomp" line="start: 0 0 0; end: 0.15 0 0; color: #e7b648" :position="this.boxPositionLeft">
                                    <a-text font="exo2semibold" position="0.2 0  0" width="1" color="#e7b648" :value="parseFloat(this.rotationAngleX).toFixed(2)"></a-text>
                                </a-entity>
                                <a-entity position="-0.05 0 0.2" rotation="0 30 0" particle-grid="gridWidth: 5; gridHeight:20; distance: 0.05; scale: 0.001; color: #ffffff"></a-entity>
    
                            </a-entity>
    
    
                            <a-entity v-if="hud >= 1" @mousedown="playChirp(2000, 0.1, 0.02)" id="rightstack" width="1" line-stack :position="calculateRightComplication()">
                                <a-entity class="ignored" connecting-line__1="start:#rightstack;startOffset: 0 0 0 ;end:#rightcomp;endOffset:  0 0 0; color:#e7b648">
                                </a-entity>
                                <a-entity id="rightcomp" line="start: 0 0 0; end: -0.15 0 0; color: #e7b648" :position="this.boxPositionRight">
                                    <a-text font="exo2semibold" align="right" position="-0.2 0  0" width="1" color="#e7b648" :value="parseFloat(this.rotationAngleY).toFixed(2)"></a-text>
                                </a-entity>
                                <a-entity position="0.05 0 0.2" rotation="0 -30 0" particle-grid="gridWidth: 5; gridHeight:20; distance: 0.05; scale: 0.001; color: #ffffff">
    
    
    
                                </a-entity>
    
                            </a-entity>
    
    
                            <a-entity id="hand" laser-controls="hand: right"></a-entity>
    
                            <!-- Change hand to `hand` for VR. -->
                            <a-entity v-if="!cursor" id="keyboard" :super-keyboard="{
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        hand: '#cursor',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        imagePath: 'dist/',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        show: !cursor
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        }"
                                :position="isDesktop() ? '0 -0.1 -0.5' : '0 -0.1 -1'" rotation="0 0 0">
    
    
                            </a-entity>
                        </a-entity>
                    </a-camera>
                </a-entity>
    
    
    
    
                <!-- <a-entity position="2 0 64">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <a-sphere position="-1.5 0 0" color="yellow" radius="1"></a-sphere>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        <a-text position="0 0 0" :value="markerPositions[2].title" font="https://cdn.aframe.io/fonts/Exo2Bold.fnt"></a-text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        </a-entity>-->
    
    
                <AFrameIcosahedralGlobe @requestMarkerRemoval="preloadMarkerRemoval" @latitudeLongitude="handleLatitudeLongitude" @titleDescLink="handleTitleDescLink" :muteStatus="muted" :timeScale="timescale" :efficient="efficient" :markerPositions="markerPositions"
                    @globeIntersection="updateCoordinates">
    
                    <template #default="{ position, title, description, link }">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 <a-entity geometry="primitive: box" material="shader: html; target: #htmlElement"></a-entity>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          <a-entity :position="position" class="raycastable"  raycaster="objects: .interactive .raycastable" @mouseenter="onMarkerMouseEnter(title, description, link, index)" @mouseleave="onMarkerMouseLeave"></a-entity>
</template>

          </AFrameIcosahedralGlobe>          


        <div class="marker-tooltip" v-if="markerTooltip.visible">
          <h2>{{ markerTooltip.title }}</h2>
          <p>{{ markerTooltip.description }}</p>
          <a :href="markerTooltip.link">{{ markerTooltip.link }}</a>
        </div>
  

      </a-scene>




    <!-- HTML SHADER INJECTION -->




      <div class="segmentbutton" :style="[streamVisible ? {'filter' : 'invert(1)'} : {'filter' : 'invert(0)'}]" @click="streamVisible = !streamVisible"></div>
      <div class="screenshot" @click="screenshot()"></div>
      
      

      <div  class="fade-in-anim, intro-cover" style="display:none;flex-flow:column;justify-content: center;">
            
            <div class="title" style=""> <h1>NOCLIP</h1> </div>

        <div class="complications" style="">
            <div class="left-complication" style=""> 

                <div class="social-diag">
                    <div class="socialbutton">
                        <p>TELEGRAM</p>
                    </div>
                    <div class="socialbutton">
                        <p>TWITTER</p>
                    </div>
                    <div class="socialbutton">
                        <p>DISCORD</p>
                    </div>
                </div>
                <div class="company-buttonrow"><div class="companybutton">PBC</div><div class="companybutton">GEC</div><div class="companybutton">DDC</div></div>

                <p style="border-top:1px dashed #fffa;padding-top:10px;width:200px;line-height:1.2;text-align:left;"><b>NOCLIP</b> is a project compiled by <b>POINTBLANK LLC</b> in collaboration with <b>GEOMETRIC ENERGY CORPORATION</b> and <b>DEFY DEVELOPMENT CORP</b></p>
                <div class="company-buttonrow"><div class="companybutton">THE VISION</div></div>
 <p style=" border-top:1px dashed #fffa;padding-top:10px;margin-bottom:50px;width:200px;line-height:1.2;text-align:left;">FRANK WHITE coined the term the 'overview effect' after numerous in-depth conversations with the few human beings who have ventured beyond our boundary conditions that lead to modern life.</p>
                                
                </div>  
            <div style="" class="center-complication"> 
            <div class="top-menu-add" style="">
            <div class="top-menu-corner" style=""></div>
                <div class="top-menu-block">

                </div>
                    
                </div>
            <div class="data-box-row" style="display:flex;flex-flow:row;gap:20px;">
                    <div class="data-box" style=""> <p class="time">{{ currentTime }}</p>   


                    </div>
                    <div class="data-box-ip" style=""> <p class="ipaddress">72.177.171.171 <!--{{ ipAddress }}--></p>   


                    </div>
                    <div class="data-box2" style=""> 
                    <div class="passport">
                    <p>Your Latitude: <b>{{ latitude }}</b></p>
                        <p>Your Longitude: <b>{{ longitude }}</b></p></div>
                        <button @click="getUserLocation"><p>Get Location</p></button>
                    </div>
                </div>
            <div class="central-viewport">
                <div class="screen-constraint" style="position:relative;z-index:5;width:calc(100% - 4rem);height:calc(100% - 4rem);margin:2rem;">
                <iframe src="https://player.vimeo.com/video/867526170?h=5ac694b416&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="box-shadow:0px 0px 100px black;border-radius:4px;position:relative;top:0;left:0;width:100%;height:100%;"
                  title="NOCLIP V4 MASTER PRORES"></iframe></div>
                <div class="viewport-corners">
                    <div class="viewport-corner-1"></div>
                    <div class="viewport-corner-2"></div>
                    <div class="viewport-corner-3"></div>
                    <div class="viewport-corner-4"></div>
                </div>

            </div>
                <div class="cta-main-page">
                    <div class="cta-title-tag">
                        <h2 style="margin-bottom:0.5rem;font-size:2.45rem;margin-top:-0.5rem;">THE OVERVIEW EFFECT FOR EVERYONE</h2>
                        <p style="font-size:0.80rem;margin-bottom:1.2rem;"> <b>Your player has clipped outside the playable area! </b> Beyond the thin veil of gas and electromagnetics that buffers infinity</p>
                    </div>
                    <div  @mousedown="this.startOverviewEffect({x: 20, y: -5, z: 5}, {x: -30, y: 20, z: -90}, 2000); " class="overlays" style="">OVERLAYS <div class="button-arrow"></div></div>
                </div>


                
                    <div class="bottom-menu-block">
                        
                    </div>  
                </div>  

                
            </div>

            <div class="warning-strip" style=""> 

            </div>


            </div>



            <div v-if="!stream"  class="fade-in-anim, intro-cover" style="perspective:600px;"  @wheel="handleScrollEvent" @touchstart="handleTouchStart" @touchmove="handleScrollEvent">
                <div class="grid"><div class="vertical-raster-lines line-1"></div><div class="vertical-raster-lines line-2"></div><div class="vertical-raster-lines line-3"></div><div class="vertical-raster-lines line-4"></div><div class="vertical-raster-lines line-5"></div><div class="vertical-raster-lines line-6"></div><div class="vertical-raster-lines line-7"></div><div class="vertical-raster-lines line-8"></div><div class="vertical-raster-lines line-9"></div><div class="vertical-raster-lines line-10"></div><div class="vertical-raster-lines line-11"></div><div class="vertical-raster-lines line-12"></div><div class="vertical-raster-lines line-13"></div><div class="vertical-raster-lines line-14"></div><div class="vertical-raster-lines line-15"></div><div class="vertical-raster-lines line-16"></div><div class="vertical-raster-lines line-17"></div><div class="vertical-raster-lines line-18"></div><div class="vertical-raster-lines line-19"></div><div class="vertical-raster-lines line-20"></div><div class="vertical-raster-lines line-21"></div><div class="vertical-raster-lines line-22"></div><div class="vertical-raster-lines line-23"></div></div>

<div class="top-content" style="z-index:12;width:calc(100vw - 2rem);gap:1rem;padding:1rem;position:fixed;top:0px;right:0px;display:flex;flex-flow:row;justify-content:space-between;"  >
    <div class="top-left-content" style="display:flex;flex-flow:row;"> <div class="noclip">  <p><b>{{ wheelcount }}</b></p></div>  </div>
    <div class="top-middle-content" style="display:flex;flex-flow:column;justify-content:center;">
        <div @click="this.playChirp(10 * wheelcount + 500, 0.1, 0.01);" class="arrownav" style="height:2rem;display:flex;flex-flow:row;">
             <div @click="this.wheelcount -= 10, this.processMovement('up')" class="back-arrow"><img style="transform:rotate(180deg);height:2rem;" src="arrow-next-yellow.svg" alt=""><img style="transform:rotate(180deg);height:2rem;" src="arrow-next.svg" alt=""></div>
        <div class="middle-slider" style="display:flex;flex-flow:column;justify-content:center;width:200px;max-width:30vw;">             
            <vue3-slider
    v-model="wheelcount"
    color="#e7b648"
    track-color="#33333355"
    height="3"
    max="140"
    @dragging="handleDragging"
  /></div>
        <div @click="this.wheelcount += 10, this.processMovement('down')" class="forward-arrow"><img style="height:2rem;" src="arrow-next-yellow.svg" alt=""><img style="height:2rem;" src="arrow-next.svg" alt=""></div>
    </div>
    </div>
      <div class="top-right-content" style="display:flex;flex-flow:row;gap:0.2rem;"><div class="socials-wrapper"   @click="this.playChirp(80, 0.1, 0.01);" style="">
       <div class="menu-strip"> <a target="_blank" href="https://twitter.com/NOCLIPTOKEN" style="line-height:1rem;"><img style="height:0.8rem;margin:auto;" src="~/@/assets/x.svg"></a> </div>
       <div class="menu-strip"><a target="_blank" href="https://discord.gg/2Kt8Rchsxe" style="line-height:1rem;"> <img style="height:1rem;margin:auto;margin-top:-0.05rem;" src="~/@/assets/discord.svg"></a></div>
       <div class="menu-strip"> <a target="_blank" href="https://t.co/xcSTtCmNIz" style="line-height:1rem;"><img style="height:1rem;margin:auto;margin-top:-0.2rem;" src="~/@/assets/telegram.svg"></a></div>
      </div></div>
</div>


<transition name="fade-scale" @after-leave="afterLeave" >
                <div v-if="showIntro" ref="intro" @mousemove="moveLogo" class="tutorial-intro" style="z-index:2;height:calc(100vh - 8rem);display:flex;flex-flow:column;justify-content:center;width:100vw;top:4rem;position:fixed;">

                    <div class="title-stack"  :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="">
                        <div class="title-top-data" style="">
                            <div class="arrow" style="display:flex;flex-flow:row;width:25%;">
                            <img style="height:24px;margin:auto;" src="ethereum-soft.svg" alt=""><div class="line-arrow" style="width:calc(100% - 1rem);margin-top:auto;margin-bottom:auto;height:1rem;background-image:url(line2.svg);background-repeat:no-repeat;background-size:contain;background-position:left center;margin-left:0rem;margin-right:1rem;"></div></div>
                            <p style="display:block ruby;text-align:right;" class="spacemono" ref="noclipMainDesc"></p></div>

                            <div class="warning-strip" style="display:none!important;" > 
                            <div class="warning-strip-filler" :style="{ right: rightValue + '%'}">
                                <div class="warning-strip-filler" style="background-color:#333;z-index:1; content:'loaded';color:black;   width: 100%;" :style="{ opacity: `${(wheelcount - 40) * 0.1}` }">
                                </div>
                            </div>
                        </div>
                           
                        <div class="title-middle-data"><h1 style="" ref="noclipMainTitle"></h1></div>
                        <div class="row-buttons home-row" style="">
                                <div  @click="this.wheelcount = 60, this.processMovement('down')" class="overlays" style=""><p>CUBESAT</p> <img style="" src="arrow-next.svg" alt=""></div>
                                <div  @click="this.wheelcount = 120, this.processMovement('down') " class="overlays" style=""><p>STREAM</p> <img style="" src="arrow-next.svg" alt=""></div>
                                <div  @click="this.wheelcount = 130, this.processMovement('down')" class="overlays" style=""><p>ERC20</p> <img style="" src="arrow-next.svg" alt=""></div>
                            
                            
                            </div>


                        <div class="title-bottom-data" style=""><p style="display:block ruby;" class="spacemono" ref="noclipSecondaryDesc"></p> 
                        <div class="arrow" style="display:flex;flex-flow:row;width:50%;"><div class="line-arrow" style="width:calc(100% - 1rem);margin-top:auto;margin-bottom:auto;height:1rem;background-image:url(line1.svg);background-repeat:no-repeat;background-position:right center;background-size:contain;margin-right:-5px;margin-left:1rem;"></div> <img style="height:24px;margin:auto;" src="arrow-next.svg" alt=""></div></div>
                   
                   
                    </div>
                    <div class="intro-guide"  :class="{ exists: wheelcount <= 50 }" :style="{ opacity: `${(50 - wheelcount) * 0.02}` }"  style=""><p style="position:relative;margin:auto;display:flex;width:max-content;text-align:center;">SCROLL / SWIPE</p> 
                        <div style="display:flex;flex-flow:row;justify-content:center;width:100%;"> <img style="animation:scrollguide 3s ease infinite;height:50px;width:50px;margin:25px;" src="arrow-next.svg" alt=""></div>
                    </div>
                </div>

            </transition>


            <transition name="fade-scale" @after-leave="afterLeave" >
                <div v-if="showAbout && this.wheelcount <= 110" ref="intro" @mousemove="moveLogo" class="tutorial-intro" style="z-index:2;height:calc(100vh - 8rem);display:flex;flex-flow:column;justify-content:center;width:100vw;top:4rem;position:fixed;">

                                <div class="about-stack"  :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="">
                                    <div class="about-area-a"> <div :class="{ orangeback: wheelcount >= 110 }" style="" @click="this.wheelcount = this.wheelcount + 10, this.processMovement('down')">
                                        <img :class="{ inverted: wheelcount >= 60 }" style="" src="arrow-next.svg" alt="">
                                        <img :class="{ inverted: wheelcount >= 70 }" style="" src="arrow-next.svg" alt="">
                                        <img :class="{ inverted: wheelcount >= 80 }" style="" src="arrow-next.svg" alt="">
                                        <img :class="{ inverted: wheelcount >= 90 }" style="" src="arrow-next.svg" alt="">
                                        <img :class="{ inverted: wheelcount >= 100 }" style="" src="arrow-next.svg" alt="">
                                        <img :class="{ inverted: wheelcount >= 110 }" style="" src="arrow-next.svg" alt="">
                                                            </div> </div>
                                    <div class="about-area-b" style="">    
                                        <div class="central-viewport">
                            <div class="screen-constraint" style="">
                            <div class="blurback-about"><div class="image-wrapper">
                                    <div :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(30px)` }" class="image-backdrop">
                                    
                                        <transition name="fade-scale" @after-leave="afterLeave" >
                                        <img  :class="{ exists: wheelcount >= 60 && wheelcount < 70 }" :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="display:none;width:300px;margin:auto;" src="camera1.png">
                                    </transition>
                                        <transition name="fade-scale" @after-leave="afterLeave" >
                                        <img :class="{ exists: wheelcount >= 70 && wheelcount < 80  }" :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="display:none;width:300px;margin:auto;" src="sat_box-front.png">
                                    </transition>
                                        <transition name="fade-scale" @after-leave="afterLeave" >
                                        <img :class="{ exists: wheelcount >= 80 && wheelcount < 90  }" :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="display:none;width:300px;margin:auto;" src="sat_box-iso.png">
                                    </transition>
                                        <transition name="fade-scale" @after-leave="afterLeave" >
                                        <div style="width:300px;height:300px;margin:auto;flex-flow:column;justify-content:center;background:black;border-radius:100%;display:none;"  :class="{ existsflex: wheelcount >= 90 && wheelcount < 100  }" :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" ><img style="width:150px;margin:auto;"  src="xisp.webp"></div>
                                    </transition>
                                    <transition name="fade-scale" @after-leave="afterLeave" >
                                        <img :class="{ exists: wheelcount >= 100 && wheelcount < 110  }" :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="display:none;width:300px;margin:auto;" src="espa.png">
                                    </transition>
                                    <transition name="fade-scale" @after-leave="afterLeave" >
                                        <img :class="{ exists: wheelcount >= 110 && wheelcount < 120  }" :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="display:none;width:300px;margin:auto;" src="gec.svg">
                                    </transition>

                                    </div>
                                </div>
                                <div class="text-area-about" style="">

                                    <div style="display:none;"   :class="{ exists: wheelcount >= 60 && wheelcount < 70 }">
                                        <h1 style="margin:unset;">A SMALL PAYLOAD WITH <span style="color:#fffa;text-shadow:2px 2px 0px black;">MASSIVE</span> IMPACT</h1>
                                        <p>NOCLIP-1's primary mission is to bring the transformative experience of the "overview effect" to humanity by streaming it from orbit. This awe-inspiring phenomenon, observed by astronauts in space, offers a profound shift in perspective about our planet. This extraordinary experience will be made available to everyone through immersive virtual reality (VR) technology, providing an unparalleled opportunity for people around the world to virtually step into the shoes of an astronaut and witness our planet from the vantage point of low Earth orbit.</p>
                                        <a target="_blank" href="https://youtu.be/oFjAtNBb4cU?t=142">   <div class="button-small" style=""><p>THE OVERVIEW EFFECT</p> <img style="" src="arrow-next.svg" alt=""></div></a>

                                    </div>
                                    <div style="display:none;"   :class="{ exists: wheelcount >= 70 && wheelcount < 80 }">
                                        
                                        <h1 style="margin:unset;">HIGH FIDELITY <span style="color:#fffa;text-shadow:2px 2px 0px black;">LIVESTREAM</span> FROM ORBIT</h1>
                                        <p> Exobotics Ltd has ingeniously designed a custom assembly, combining a 4k CCD with an Entaniya wide depth-of-field lens, specially adapted for the demanding orbital environment. This payload strives to provide the most authentic representation of the overview effect, accounting for factors such as glare, high ultraviolet levels, and contrast that must be considered when emulating the view from a spacesuit.</p>
                                        <a target="_blank" href="https://www.prnewswire.com/news-releases/geometric-energy-to-launch-aboard-falcon-9-rideshare-mission-301260498.html">   <div class="button-small" style=""><p>PRESS RELEASE</p> <img style="" src="arrow-next.svg" alt=""></div></a>

                                    </div>
                                    <div style="display:none;"   :class="{ exists: wheelcount >= 80 && wheelcount < 90 }">
                                    
                                        <h1 style="margin:unset;">DESIGNED AND <span style="color:#fffa;text-shadow:2px 2px 0px black;">FABRICATED</span> BY THE PROS</h1>
                                        <p>Exobotics, a space hardware testing equipment company, is the mastermind behind NOCLIP-1 and its custom satellite. Their expertise has guided the entire process, helping a young company like ours navigate the intricacies of the space industry, uncovering unforeseen challenges as we ventured into the realm of space exploration.</p>
                                        <a target="_blank" href="https://exobotics.space/">   <div class="button-small" style=""><p>EXOBOTICS</p> <img style="" src="arrow-next.svg" alt=""></div></a>

                                    </div>
                                    <div style="display:none;"   :class="{ exists: wheelcount >= 90 && wheelcount < 100 }">
                                        
                                        <h1 style="margin:unset;">COORDINATED BY SEASONED <span style="color:#fffa;text-shadow:2px 2px 0px black;">SPACE INDUSTRY</span> VETERANS</h1>
                                        <p> XISP has played a pivotal role in managing the complex bureaucratic aspects of our mission, ensuring a seamless connection between our grand objective of delivering a CubeSat that broadcasts an overview-effect equivalent livestream from low Earth orbit and the multifaceted logistical considerations necessary for a legal and safe launch. From coordination with the FCC to bandwidth allocation and orbital characteristics definition, XISP has been a critical partner.</p>
                                        <a target="_blank" href="http://www.xisp-inc.com/">   <div class="button-small" style=""><p>XISP INC</p> <img style="" src="arrow-next.svg" alt=""></div></a>

                                    </div>
                                    <div style="display:none;"   :class="{ exists: wheelcount >= 100 && wheelcount < 110 }">
                                        
                                        <h1 style="margin:unset;">INTEGRATED BY THE CREATORS OF THE <span style="color:#fffa;text-shadow:2px 2px 0px black;">CUBESAT</span> STANDARD</h1>
                                        <p>Maverick Space, as the integrator of NOCLIP-1, oversees the final stages before launch. They meticulously test the system, ensuring structural integrity and perfecting the deployment sequence. Additionally, they have been instrumental in the shift towards CubeSat standardization, making low-cost orbital infrastructure accessible for academic, scientific, and artistic endeavors.</p>
                                        <a target="_blank" href="https://www.maverickspace.com/">   <div class="button-small" style=""><p>MAVERICK</p> <img style="" src="arrow-next.svg" alt=""></div></a>

                                    </div>
                                    <div style="display:none;"   :class="{ exists: wheelcount >= 110 && wheelcount < 120 }">
                                        
                                        <h1 style="margin:unset;">LAUNCH SERVICES FROM <span style="color:#fffa;text-shadow:2px 2px 0px black;">THE BEST</span> IN THE WORLD</h1>
                                        <p>Our chosen delivery vehicle is the SpaceX Falcon 9, and in collaboration with Geometric Energy Corporation, we have secured payload space on their initial LEO missions. NOCLIP-1 will join parallel CubeSats after aligning with governing bodies and integrating necessary additional costs and licensure, thus enabling injection into low Earth orbit, marking the culmination of this groundbreaking mission.</p>
                                        <a target="_blank" href="https://www.spacex.com/vehicles/falcon-9/">   <div class="button-small" style=""><p>FALCON 9</p> <img style="" src="arrow-next.svg" alt=""></div></a>

                                </div>

                                </div>
                            </div>
                            <div class="viewport-corners">
                            <div class="viewport-corner-1"></div>
                            <div class="viewport-corner-2"></div>
                            <div class="viewport-corner-3"></div>
                            <div class="viewport-corner-4"></div>
                        </div>
                    </div>
                   
                   
                   
                    <div  @click="this.wheelcount = 130, this.processMovement('down')" class="overlays" style=""><p>NOCLIP ERC20</p> <img style="" src="arrow-next.svg" alt=""></div>
               
               
               
                </div>
                    </div>
                    </div>
                </div>

            </transition>

            <transition name="fade-scale" @after-leave="afterLeave" >
                <div  v-if="showInteractive || this.wheelcount > 110 && this.wheelcount < 130" ref="intro" @mousemove="moveLogo" class="tutorial-intro" style="z-index:2;height:calc(100vh - 8rem);display:flex;flex-flow:column;justify-content:center;width:100vw;top:4rem;position:fixed;">
                    <div style="margin:auto;">
                    <h1 ref="noclipConstruction" style="margin: unset ;margin-bottom:0.5rem;text-align:center;"></h1>
                    <p style="margin: unset ;text-align:center;color:#fffa;">UNDER CONSTRUCTION</p>
                    <div class="row-buttons" style="display:flex;flex-flow:row;margin-top:16vh;gap:0.5rem;z-index:20;position:relative;">
                             
                        
                        <div @click="this.startOverviewEffect({x: 0, y: 0, z: 0}, {x: 0, y: 0, z: 0}, 2000), resetCameraX, this.stream = true, this.efficient = true, this.hud = 4, this.timescale = 0.1" class="overlays" style=""><p>PREVIEW</p> <img style="" src="arrow-next.svg" alt=""></div>
                        <div  @click="this.wheelcount = 130, this.processMovement('down'), this.showAbout = true" class="overlays" style=""><p>ERC20</p> <img style="" src="arrow-next.svg" alt=""></div>
                            
                            
                            </div>
                </div>
                </div>

            </transition>



<!-- THIS IS FOR WEB3 INTEGRATION SER BACKEND DEV-->


                    <transition name="fade-scale" @after-leave="afterLeave" >

                        <div v-if="showErc || this.wheelcount >= 130" ref="intro" @mousemove="moveLogo" class="tutorial-intro" style="z-index:2;height:calc(100vh - 8rem);display:flex;flex-flow:column;justify-content:center;width:100vw;top:4rem;position:fixed;">



                            <div class="panel" style="display:none;">

                            <h1 style="margin-top:unset;">MINT NOCLIP</h1>

                                <p>Number Of Remaining Noclip</p> {{ mintableNoclip }}
                                <p>Number of Holders</p>
                                
                                <p>Wallet Address</p><EtherAddress :address="wallet.address" />
                                <p>Total Eth in Wallet</p>{{ ethersBalance }}
                                <p>Total Noclip in Wallet</p> {{ noclipBalance }}
                                <input v-if='wallet.address != ""' type="number" placeholder="10 eth" style="border:2px solid #fffa; border-radius:0px;margin-bottom:0.5rem;margin-top:1rem;" v-model="amount" >  <!--NOCLIP INPUT BOX-->
                                <input v-if='wallet.address != "" && this.loading == false' type="submit" style="border:2px solid #fffa; border-radius:0px;" @click="buyNoclip">  <!--NOCLIP PURCHASE BUTTON-->
                                <button v-if='wallet.address == ""' type="button" style="border:2px solid #fffa; border-radius:0px;" @click="connectWallet">Connect Wallet</button>  <!--NOCLIP PURCHASE BUTTON-->
                            
                            </div>





                            <div class="mint-stack"  :style="{ transform: `rotatey(${logoX})rotatex(${logoY})translatez(60px)` }" style="">
                                    <div class="about-area-a"> <div class="readerbar" style="">
                                        <div class="filler-user "  :style="{ height: `${ (100 - (100 - ((this.amount * 1000) / 1000000 * 100))).toFixed(4)}%` }"></div>
                                        <div class="filler warning-back"  :style="{ height: `${100 - (mintableNoclip / 1000000 * 100)}%` }"></div>
                                        <div class="filler-mobile warning-back-horizontal"  :style="{ width: `${100 - (mintableNoclip / 1000000 * 100)}%` }"></div>
                                        <div class="filler-user-mobile"  :style="{ width: `${ (100 - (100 - ((this.amount * 1000) / 1000000 * 100))).toFixed(4)}%` }"></div>

                                                            </div> </div>
                                    <div class="about-area-b" style="">    
                                        <div class="central-viewport">

                                            <div  v-if='wallet.address == ""'  @click="connectWallet" class="overlays" style=""><p>CONNECT WALLET</p> <img style="" src="arrow-next.svg" alt=""></div>
                                            <div  v-if='wallet.address != "" && this.loading == false' class="overlays" style="justify-content:space-between;"><p style="background:#555;padding:0.5rem;border-radius:0px;margin:-0.5rem;">{{ ethersBalance }} ETH</p>  <EtherAddress style="font-family: 'Space Mono', monospace!important;" :address="wallet.address" /> </div>
                                            <div  v-if='wallet.address != "" && this.loading == true' class="overlays" style="justify-content:space-between;"><p style="background:#555;padding:0.5rem;border-radius:0px;margin:-0.5rem;color:#fffa;">{{ ethersBalance - amount}} ETH</p>  <EtherAddress style="font-family: 'Space Mono', monospace!important;" :address="wallet.address" /> </div>

                            <div class="screen-constraint" style="">
                            <div class="blurback-about">
                                <div class="text-area-about " style="">

                                    <div class="mint-wrapper">
                                        <h1 style="margin:unset;margin-bottom:1rem;">MINT <span style="color:#fffa;text-shadow:2px 2px 0px black;">NOCLIP</span> ERC20</h1>
                                        
                                       <div  v-if='wallet.address != ""' class="mint-details"> 
                                        <div class="balance-info"><p style="">NOCLIP REMAINING</p><div class="line"></div>  <p><b  style="color:#fffa;  text-shadow: 0px 0px 5px;">{{ mintableNoclip }}</b></p></div>
                                        <div class="balance-info"><p style="">NOCLIP ACQUIRED</p> <div class="line"></div> <p> <b style="color:#fffa;  text-shadow: 0px 0px 5px;">{{ (100 - (mintableNoclip / 1000000 * 100)).toFixed(2) }}%</b></p> </div>
                                        <div class="balance-info"><p style="">YOUR NOCLIP</p><div class="line"></div> <p><b  style="color:#fffa;  text-shadow: 0px 0px 5px;">{{ noclipBalance }}</b></p></div>
                                        </div>
                                        <div class="contract-info" v-if='wallet.address != ""' >
                                            <a class="whitepaper" href="NOCLIP.pdf" target="download"><p style="margin:unset;">LITEPAPER</p></a>
                                            <div class="contract">   
                                                <!-- YEAH, SO WE BROKE SOME RULES REGARDING BEST PRACTICES WITH CONSISTENT NESTED BORDER-RADIUS, WHAT U GONNA DO ABOUT IT :P -->           
                                                
                                                <p style="margin:unset;margin-bottom:0.5rem;font-size:0.5rem;margin-top:unset;text-align:center;"> <b  style="color:#fffa;">{{ contract }}</b></p>
                                           <a style="margin: 0px auto;" target="_blank" href="https://etherscan.io/address/0x36B17ff04654ba7031b1a3D8eAd3016A15262287"> <p style="text-align:center;margin:unset;"><b  style="color:white;">NOCLIP CONTRACT</b></p></a>
                                        </div></div>


             
                                        <div style="display:flex;flex-flow:row;padding: 0px 0.5rem; background: #181818;margin: 0.5rem 0rem; border-radius: 0px;"> <input v-if='wallet.address != ""' type="number" placeholder="0.01 ETH" style="background-color:white; border-radius:0px;margin:unset;margin-bottom:0.5rem;margin-top:0.5rem;" v-model="amount" >  <!--NOCLIP INPUT BOX-->
                                            <div v-if='wallet.address != "" && this.ethersBalance < 0.003' class="button-small"  style=" color:#fffa;" > <p>NO ETH</p></div>

                                            <div v-if="this.ethersBalance > 0.003" class="">
                                            <div class="button-small" v-if='wallet.address != "" && this.loading == false && this.amount < this.ethersBalance && this.amount != null && this.amount != 0' style=" " @click="buyNoclip"> <p class="mint">MINT</p></div>
                                            <div class="button-small" v-if='wallet.address != "" && this.loading == false && this.amount >= this.ethersBalance' style=" " @click="this.amount = this.ethersBalance - 0.005"> <p>AUTO</p></div>
                                            <div class="button-small" v-if='wallet.address != "" && this.loading == false && this.amount == 0' style=" " @click="this.amount = this.ethersBalance - 0.005"> <p>AUTO</p></div>
                                            <div class="button-small" v-if='wallet.address != "" && this.loading == false && this.amount == null' style=" " @click="this.amount = this.ethersBalance - 0.005"> <p>AUTO</p></div>
                                            <div class="button-small" v-if='wallet.address != "" && this.loading == true' style=" "> <p>LOADING</p></div>
                                    </div>  </div>
                                    <div class="tx-info" v-if="this.amount != null && this.amount != 0" style="">
                                        <p >You will receive <b  style="color:#fffa;  text-shadow: 0px 0px 5px;">{{ this.amount * 1000 }}</b> NOCLIP</p>
                                        <p ><b style="  text-shadow: 0px 0px 5px;">{{ (100 - (100 - ((this.amount * 1000) / 1000000 * 100))).toFixed(4) }}%</b> of all NOCLIP</p></div>

                                    <div  v-if='wallet.address == ""' class="information" style="border:3px dashed #fffa;padding:1rem;border-radius: 0px;margin-bottom:1rem; color:#e7b648"><p style="margin:unset;text-align:center;">YOU MUST HAVE A METAMASK ENABLED BROWSER AND ETH TO CONNECT / USE THIS INTERFACE</p></div>
                                    
                                    <div @click="disclaimerOpen = !disclaimerOpen" style="padding:1rem;display:flex;flex-flow:wrap;justify-content:space-between;margin-top:0rem;margin-bottom:0rem;background-color:#555;border-radius: 0px;"> 
                                            <p style="margin:auto 0px;margin-right:auto;line-height:1!important;" v-if="!disclaimerOpen">DISCLAIMER</p><img  v-if="!disclaimerOpen" style="width:1rem;margin-left:auto;position:relative;" src="arrow-next.svg" alt="">
                                        <p   :class="{ disclaimerOpen: disclaimerOpen }" style="width:100%;transition:all 0.2s ease;height:0rem;overflow:hidden;margin:unset;font-size:0.5rem;">The <b>NOCLIP UTILITY TOKEN</b> is an ERC20 token, which has been developed as a web3 access token to activate augmentation of the base livestream soon available on NOCLIP.ORG <br> <br>Some features / overlays will take longer to develop, and may not be available immediately upon launch. <br> <br>Your patience as a supporter of this project is appreciated, and you may provide feedback publically or privately via telegram to help us improve!</p>
                                        </div>
                                    </div>
                                  
                                 

                                </div>
                            </div>
                            <div class="viewport-corners">
                            <div class="viewport-corner-1"></div>
                            <div class="viewport-corner-2"></div>
                            <div class="viewport-corner-3"></div>
                            <div class="viewport-corner-4"></div>
                        </div>
                    </div>
                   
                   
                   
               
               
               
                     </div>
                    </div>
                    </div>

                </div>





            </transition>

<!-- THIS IS FOR WEB3 INTEGRATION SER BACKEND DEV-->



<div class="bottom-content"  style="">
    <div class="bottom-left-section">
    <div class="bottom-left-content" style="display:flex;flex-flow:row;"><p><b>IP ADDRESS: </b>{{ ipAddress }}</p></div>
    <div class="bottom-right-content" style="display:flex;flex-flow:row;"><p @click="getUserLocation">{{ latitude }} <b style="color:e7b648;"><b v-if="latitude || longitude">|</b></b> {{ longitude }}</p></div>
    <div class="bottom-center-content" style="display:flex;flex-flow:row;"> <p >{{currentTime}} <b style="display:none;margin-left:auto;color:#fffa;"><img src="~/@/assets/globe.svg" style="margin:auto;height:1rem;" alt=""></b></p></div>
</div>
<div class="bottom-right-section"></div>
</div>

</div>


      <div style="z-index:-2; display:none;" class="debug-controls" id="my-interface" :class="{ menuOpen: menuActive }">
         
        <div @click="menuActive = !menuActive" class="close" :class="{ menuClose: !menuActive }"  @mouseover="playChirp(2000, 0.01, 0.05)"></div>
        <div class="debug-wrapper" :class="{ menuHidden: !menuActive }">
          <div class="buttonrow">
              <div class="circlebutton" @mousedown="playChirp(1000, 0.1, 0.02)" style=""  @mouseenter="playChirp(9000, 0.01, 0.01)"  @click="muted = !muted"><img src="~/@/assets/unmute.svg"  v-if="!muted"  style="width:16px;" alt=""><img src="~/@/assets/mute.svg" v-if="muted" style="width:16px;" alt=""></div>
              <div id="enterAR" class="circlebutton" @mousedown="playChirp(2000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)"  style=""><img src="~/@/assets/ar-button.svg" style="width:16px;" alt=""></div>
              <div id="enterVR" class="circlebutton" @mousedown="playChirp(2000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)"  style=""><img src="~/@/assets/vr-button.svg" style="width:16px;" alt=""></div>
              <div id="eyeCursor" class="circlebutton" @mousedown="playChirp(2000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" style="" @click="cursor = !cursor"><img src="~/@/assets/eye-cursor.svg" style="width:16px;" alt=""></div>
              <div :style="efficient ? 'background-color: #fffa;' : 'background-color: white!important;'" id="effciency" class="circlebutton" @mousedown="playChirp(2000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" style="" @click="efficient = !efficient"><img src="~/@/assets/highres.svg" style="width:16px;" alt=""></div>
              <div id="equi" class="circlebutton" @mousedown="playChirp(2000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" style="" @click="getCanvas()"><img src="~/@/assets/equ.svg" style="width:16px;" alt=""></div>
              <div id="screen" class="circlebutton" @mousedown="playChirp(2000, 0.1, 0.02)" @mouseenter="playChirp(9000, 0.01, 0.01)" style="" @click="capture()"><img src="~/@/assets/screen.svg" style="width:16px;" alt=""></div>
          </div>

          <p>          Sphere: <span id="sphere-output">Calculating...</span>
</p>        <div class="button" style="color:black!important;" @click="enableLookControls()">OVERLAY</div>

          <p  style="display: flex;justify-content:space-between;position:relative;z-index:1000;width:auto;font-size:0.7rem;width:230px;">LATITUDE: <b style="color:#fffa;">{{ latReceived }}</b> LONGITUDE: <b style="color:#fffa;">{{ lonReceived }}</b></p>
         
         
           
          
          <div style="position:relative;z-index:1000;width:230px;">
              <p style="user-select:none;font-weight:100;margin:unset;margin-bottom:0.5rem;">orbit km {{ ((cameraPosition.z - 63.71) * 100).toFixed(2) }} <b @mouseenter="playChirp(9000, 0.01, 0.01)" class="smallButton" @click="cameraPosition.z = 0, playChirp(cameraPosition.z * 10, 0.1, 0.01)">RESET</b></p>
              <vue3-slider  @click="playChirp(cameraPosition.z * 10, 0.1, 0.01)"  v-model="cameraPosition.z" color="#e7b648" track-color="#FEFEFE" />        
            </div>

            <div style="position:relative;z-index:1000;width:230px;margin-top:0.4rem;">
              <p style="user-select:none;font-weight:100;margin:unset;margin-bottom:0.5rem;">second/s {{ (1 / timescale).toFixed(2) }}<b @mouseenter="playChirp(9000, 0.01, 0.01)" class="smallButton"  @click="timescale = 1, playChirp(timescale * 500, 0.1, 0.01)">REALTIME</b></p>
              <vue3-slider @click="playChirp(timescale * 500, 0.1, 0.01)" v-model="timescale" color="#e7b648" track-color="#FEFEFE"/>
            </div>

            <div style="position:relative;z-index:1000;width:230px;margin-top:0.4rem;">
              <p style="user-select:none;font-weight:100;margin:unset;margin-bottom:0.5rem;">ARC ANGLE {{arcang}}<b @mouseenter="playChirp(9000, 0.01, 0.01)" class="smallButton"  @click="timescale = 1, playChirp(timescale * 500, 0.1, 0.01)">REALTIME</b></p>
              <vue3-slider @click="playChirp(timescale * 500, 0.1, 0.01)" v-model="arcang" color="#e7b648" track-color="#FEFEFE"/>
            </div>

            <div style="position:relative;z-index:1000;width:230px;margin-top:0.4rem;">
              <p style="user-select:none;font-weight:100;margin:unset;margin-bottom:0.5rem;">ARC DEGREES {{arcdeg}}<b @mouseenter="playChirp(9000, 0.01, 0.01)" class="smallButton"  @click="timescale = 1, playChirp(timescale * 500, 0.1, 0.01)">REALTIME</b></p>
              <vue3-slider @click="playChirp(timescale * 500, 0.1, 0.01)" v-model="arcdeg" color="#e7b648" track-color="#FEFEFE"/>
            </div>

            <div style="position:relative;z-index:1000;width:230px;margin-top:0.4rem;">
              <p style="user-select:none;font-weight:100;margin:unset;margin-bottom:0.5rem;">field 0f view {{ fov }}<b @mouseenter="playChirp(9000, 0.01, 0.01)" class="smallButton"  @click="fov = 90, playChirp(timescale * 500, 0.1, 0.01)">DEFAULT</b></p>
              <vue3-slider @click="playChirp(fov * 500, 0.1, 0.01)" v-model="fov" max="170" color="#e7b648" track-color="#FEFEFE"/>
            </div>


      <div class="input-box"  style="border:1px solid #fffa;border-radius:4px;position:relative;z-index:1000;margin-top:1rem;display: block;width:auto;background:#0004; backdrop-filter:blur(10px);padding:0.5rem 1rem;">
        <div class="row"><p>LAT</p> <input style="margin-top:unset;margin-bottom:unset;color:#fffa;font-family: 'Space Mono', monospace; font-size:1rem;" v-model="latReceived" type="number" placeholder="0.00">
        <input style="margin-top:unset;margin-bottom:unset;border-top:unset;color:#fffa;font-family: 'Space Mono', monospace; font-size:1rem;" v-model="lonReceived" type="number" placeholder="0.00">
        <p>LON</p></div><input style="margin:unset;margin-top:0.5rem;border-top:unset;color:#fffa;font-family: 'Space Mono', monospace; font-size:1rem;" v-model="titleReceived" type="text" placeholder="Title">
        <input style="margin:unset;border-top:unset;color:#fffa;font-family: 'Space Mono', monospace; font-size:1rem;" v-model="descReceived" type="text" placeholder="Desc">
        <input style="margin:unset;margin-bottom:1rem;border-top:unset;color:#fffa;font-family: 'Space Mono', monospace; font-size:1rem;" v-model="linkReceived" type="text" placeholder="Link">
        <button style="cursor:pointer;padding:0.5rem;margin:unset;width:100%;border:unset;color:black;margin-bottom:0.5rem;font-family: 'Space Mono', monospace; font-size:1rem;" @mouseenter="playChirp(9000, 0.01, 0.01)"  @mousedown="playChirp(1000, 0.1, 0.02)" @click="addMarker" v-if="selectedIndex == null">Add Node</button>
        <button  style="cursor:pointer;padding:0.5rem;margin:unset;width:100%;border:unset;color:black;margin-bottom:0.5rem;font-family: 'Space Mono', monospace; font-size:1rem;" @mouseenter="playChirp(9000, 0.01, 0.01)" @mousedown="playChirp(1000, 0.1, 0.02)"  @click="handleMarkerRemoval(selectedIndex)" v-if="selectedIndex !== null">
  Remove Node {{ selectedIndex }}
</button>

      </div></div>
    </div>
    </div>
  </div>
</template>

<script>
import 'aframe'
import _ from 'lodash'; // Importing lodash
import 'aframe-extras'
import 'aframe-web-portals'
import "aframe-rounded-box-component"
import 'aframe-effects' // Import aframe-effects
import { ethers } from 'ethers';
import ArcEntity from '../components/ArcEntity.vue';
import ArcEntityDeg from '../components/ArcEntityDeg.vue';
import slider from "vue3-slider";
import AFrameIcosahedralGlobe from "../components/AFrameIcosahedralGlobe.vue";
/*import WebGPU from '../assets/threejs/examples/jsm/capabilities/WebGPU.js';
import WebGPURenderer from '../assets/threejs/examples/jsm/renderers/webgpu/WebGPURenderer.js';*/
import {
    EffectComposer,
    RenderPass,
    NoiseEffect,
    DepthOfFieldEffect,
    FXAAEffect,
    BlendFunction,
    BloomEffect,
} from 'postprocessing';
import * as THREE from 'three';
import 'aframe-globe-component' // Import aframe-effects
import * as d3 from 'd3';
import { useWalletStore } from '../stores/wallet';
import IERC20 from '../helpers/abi/IERC20.json';

import EtherAddress from '../components/EtherAddress.vue';

export default {
    name: "app",
    data() {
        return {
            audioContext: new(window.AudioContext || window.webkitAudioContext)(),
            markerPositions: [
                { lat: -15, lon: -47, title: "Marker 1", description: "Brazil", link: "https://example.com" },
                { lat: -26, lon: 133, title: "Marker 1", description: "Australia", link: "https://example.com" },
                { lat: 9, lon: 18, title: "Marker 1", description: "Africa", link: "https://example.com" },
                { lat: 20, lon: 77, title: "Marker 1", description: "India", link: "https://example.com" },
                // Add more positions as needed
            ],
            selectedMarkerIndex: -1, // Initialize with an invalid index
            markerTooltip: {
                title: "",
                description: "",
                link: "",
                visible: false,
            },
            depthOfFieldEffect: {
                focusDistance: 0.5,
                focalLength: 0.1,
                bokehScale: 2,
            },

            intro: 0,
            stream: false,

            windowHeightOpen: window.outerHeight - 420,
            windowHeightClosed: window.outerHeight - 72,
            muted: false,
            cursor: true,
            hud: 0,

            wheelcount: 0,
            enteravail: false,
            snapTimeout: null,
            cursorscale: 1,
            cursorrotationAngleY: 0,
            scrollDebounceTimer: null, // Timer to handle debounce
            accumulatedDelta: 0, // Store accumulated delta during rapid scrolls
            scrollBuffer: 0, // Buffer counter to accumulate delta during a scroll sequence

            logoX: 0,
            logoY: 0,
            logoX2: 0,
            logoY2: 0,
            logoXr: 0,
            logoYr: 0,

            fov: 90,
            deltaCounter: 0,
            touchStartY: 0,
            snapThreshold: 10,
            isProcessingScroll: false,

            startY: 0,
            arcdeg: 90,
            arcang: 45,

            cursorOuterRotation: '0, 0, 0',
            rotationGlobal: '0 0 0',
            efficient: true,
            selectedIndex: null,

            latInput: null,
            lonInput: null,
            latitude: "",
            longitude: "",

            currentTime: null,

            latReceived: 0.00,
            lonReceived: 0.00,

            prog: 1,

            showIntro: true,
            showAbout: false,
            showInterface: false,
            showOverlay: false,
            showErc: false,
            showInteractive: false,
            showAcquire: false,

            debug: false,

            material: '',

            video: false,
            rightValue: 100,
            planet: true,

            lastLat: 0.00,
            lastLon: 0.00,

            lastValue: 0,

            titleReceived: 'Title',
            descReceived: 'Desc',
            linkReceived: 'Link',

            cameraOrbitMult: 69.47,

            cameraPosition: { x: 0, y: -1.6, z: 69.47 },
            cameraDefaultPosition: { x: 0, y: -1.6, z: 69.47 },

            mouseX: 0,
            mouseY: 0,

            keyboard: false,

            look: false,
            contract: '0x36B17ff04654ba7031b1a3D8eAd3016A15262287',

            keyboardOutput: null,

            zPosition: 0,

            keyboardOutputTitle: null,
            keyboardOutputDesc: null,
            keyboardOutputLink: null,
            disclaimerOpen: false,
            menuActive: false,
            earthRadius: 63.71,
            timescale: 1,
            sceneEl: null,
            renderer: null,
            ipAddress: "",
            camera: null,
            composer: null,
            stars: [],
            rotationAngleX: 0, // Initialize with the default angle
            rotationAngleY: 0, // Initialize with the default angle
            boxPositionLeft: '1.5, 0, -1',
            boxPositionRight: '-1.5, 0, -1',
            cursorRotation: '0, 0, 45',
            streamOpacity: 50,
            classificationOpacity: 0,
            streamSizeMult: 1,
            modalActive: false,
            streamVisible: true,
            markerHovered: false, // Added markerHovered property
            currentURL: "https://i.imgur.com/EQlNW3K.jpeg",
            currentURL2: "https://i.imgur.com/Ih1YFSy.jpeg",
            topDialRotation: '0 0 0',
            topDialRotationInv: '0 0 0',
            wallet: new useWalletStore(),
            noclip_balance: ethers.BigNumber.from(0),
            ethers_balance: ethers.BigNumber.from(0),
            mintable_noclip: ethers.BigNumber.from(0),
            amount: null,
            loading: false,
            metamask_error: null,
        };
    },
    mounted() {

        const updateViewportHeight = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        updateViewportHeight();
        window.addEventListener('resize', updateViewportHeight);


        this.loadAframeSceneWithDelay();
        this.created();
        this.getUserLocation();
        this.fetchIpAddress();





        this.adjustSceneSizeBound = this.adjustSceneSize.bind(this);
        this.dismissKeyboardBound = this.dismissKeyboard.bind(this);
        this.rotateCursorBound = this.rotateCursor.bind(this);
        this.moveBoxLeftBound = this.moveBoxLeft.bind(this);
        this.moveBoxRightBound = this.moveBoxRight.bind(this);
        this.updateRtcBound = this.updateRtc.bind(this);

        this.$el.addEventListener('superkeyboarddismiss', this.dismissKeyboardBound);
        window.addEventListener('resize', this.adjustSceneSizeBound);



        AFRAME.registerComponent('smooth-move', {
            schema: {
                speed: { type: 'number', default: 1 }
            },

            init: function() {
                this.mouseX = 0;
                this.mouseY = 0;
                this.origin = this.el.object3D.position.clone();
                this.position = this.el.object3D.position;
                this.tempVector = new THREE.Vector3();

                this.onMouseMove = this.onMouseMove.bind(this);
                this.onTick = this.onTick.bind(this);

                this.el.addEventListener('mousemove', this.onMouseMove);
                this.el.sceneEl.addEventListener('tick', this.onTick);
            },

            onMouseMove: function(event) {
                var rect = this.el.getBoundingClientRect();
                this.mouseX = event.clientX - rect.left;
                this.mouseY = event.clientY - rect.top;
            },

            onTick: function() {
                var rect = this.el.getBoundingClientRect();
                var xPercentage = (this.mouseX / rect.width) * 2 - 1;
                var yPercentage = (this.mouseY / rect.height) * 2 - 1;

                var xOffset = xPercentage * this.data.speed;
                var yOffset = yPercentage * this.data.speed;

                this.tempVector.set(
                    this.origin.x + xOffset,
                    this.origin.y + yOffset,
                    this.origin.z
                );

                this.position.lerp(this.tempVector, 0.1); // Adjust the lerp factor as needed
            },

            remove: function() {
                this.el.removeEventListener('mousemove', this.onMouseMove);
                this.el.sceneEl.removeEventListener('tick', this.onTick);
            }
        });

        AFRAME.registerComponent("camera-fade-in", {

            schema: {
                active: { type: 'boolean', default: true },
                duration: { type: 'float', default: 1.0 },
                color: { type: 'color', default: "black" },
            },

            init: function() {
                this.clock = new THREE.Clock();
                this.camera = document.querySelector("a-camera");

                if (this.data.active)
                    this.start();
            },

            start: function() {
                this.data.active = true;
                this.opacity = 1.0;

                // add sphere around camera
                this.cameraSphere = document.createElement("a-entity");
                this.cameraSphere.setAttribute("geometry", { primitive: "sphere", radius: 0.5 });
                this.cameraSphere.setAttribute("material", {
                    shader: "flat",
                    color: this.data.color,
                    transparent: true,
                    opacity: 1.0,
                    side: "back"
                });
                this.camera.appendChild(this.cameraSphere);

                this.finished = false;
            },

            tick: function() {
                let deltaTime = this.clock.getDelta();
                if (this.data.active && this.cameraSphere) {
                    this.opacity -= deltaTime / this.data.duration;
                    this.cameraSphere.setAttribute("material", "opacity", this.opacity);
                    if (this.opacity <= 0) {
                        this.data.active = false;
                        this.finished = true;
                        // must remove sphere, otherwise causes transparency flickering issues
                        this.camera.removeChild(this.cameraSphere);
                        this.cameraSphere = null;
                    }
                }
            }
        });

        AFRAME.registerComponent('particle-grid', {
            schema: {
                gridWidth: { type: 'number', default: 10 },
                gridHeight: { type: 'number', default: 10 },
                distance: { type: 'number', default: 1 },
                scale: { type: 'number', default: 0.1 },
                color: { type: 'color', default: '#FF0000' } // Added color property here
            },

            init: function() {
                const data = this.data;
                const el = this.el;

                for (let i = 0; i < data.gridWidth; i++) {
                    for (let j = 0; j < data.gridHeight; j++) {
                        const particle = document.createElement('a-circle');
                        particle.setAttribute('radius', data.scale);
                        particle.setAttribute('segments', 3);
                        particle.setAttribute('position', {
                            x: i * data.distance - (data.gridWidth * data.distance) / 2 + data.distance / 2,
                            y: j * data.distance - (data.gridHeight * data.distance) / 2 + data.distance / 2,
                            z: 0
                        });
                        particle.setAttribute('material', 'color', data.color); // Used color property here
                        el.appendChild(particle);
                    }
                }
            }
        });

        AFRAME.registerComponent("camera-fade-out", {

            schema: {
                active: { type: 'boolean', default: false },
                duration: { type: 'float', default: 1.0 },
                color: { type: 'color', default: "black" },
            },

            init: function() {
                this.clock = new THREE.Clock();
                this.camera = document.querySelector("a-camera");

                if (this.data.active)
                    this.start();
            },

            start: function() {
                this.data.active = true;
                this.opacity = 0.0;

                // add sphere around camera
                this.cameraSphere = document.createElement("a-entity");
                this.cameraSphere.setAttribute("geometry", { primitive: "sphere", radius: 0.5 });
                this.cameraSphere.setAttribute("material", {
                    shader: "flat",
                    color: this.data.color,
                    transparent: true,
                    opacity: 0.0,
                    side: "back"
                });
                this.camera.appendChild(this.cameraSphere);

                this.finished = false;
            },

            tick: function() {
                let deltaTime = this.clock.getDelta();
                if (this.data.active) {
                    this.opacity += deltaTime / this.data.duration;
                    this.cameraSphere.setAttribute("material", "opacity", this.opacity);
                    if (this.opacity >= 1) {
                        this.data.active = false;
                        this.finished = true;
                        // no need to remove sphere, because nothing is visible anyway
                        // this.camera.removeChild( this.cameraSphere );
                        // this.cameraSphere = null;
                    }
                }
            }
        });

        AFRAME.registerComponent('smooth-follow-mouse', {
            schema: {
                easing: { type: 'number', default: 0.1 },
                maxAngle: { type: 'number', default: 20 } // Maximum rotation angle in degrees
            },

            init: function() {
                this.targetRotation = new THREE.Euler();
                this.mouse = new THREE.Vector2();
                this.updateRotation = this.updateRotation.bind(this); // Bind this context
                this.lastUpdate = 0; // Add a timestamp of the last update
                this.updateInterval = 100; // Minimum interval between updates in milliseconds

                window.addEventListener('mousemove', this.updateRotation);
            },

            updateRotation: function(event) {
                const now = Date.now();

                // Check if the update interval has passed
                if (now - this.lastUpdate > this.updateInterval) {
                    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
                    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
                    this.lastUpdate = now; // Update the timestamp
                }
            },

            tick: function() {
                const easing = this.data.easing;
                const maxAngle = this.data.maxAngle;
                const camera = this.el.getObject3D('camera');
                const children = this.el.children;

                if (!camera) return;

                // Calculate the target rotation angles based on mouse position and the specified maximum angle
                const targetX = THREE.MathUtils.clamp(this.mouse.y * maxAngle * Math.PI / 180, -maxAngle * Math.PI / 180, maxAngle * Math.PI / 180);
                const targetY = THREE.MathUtils.clamp(-this.mouse.x * maxAngle * Math.PI / 180, -maxAngle * Math.PI / 180, maxAngle * Math.PI / 180);

                this.targetRotation.x = targetX;
                this.targetRotation.y = targetY;

                // Smoothly update the camera rotation
                camera.rotation.x += (this.targetRotation.x - camera.rotation.x) * easing;
                camera.rotation.y += (this.targetRotation.y - camera.rotation.y) * easing;

                // Smoothly update the children's rotation at half the speed
                const childEasing = easing / 2;
                for (let child of children) {
                    const childObj = child.object3D;
                    if (childObj) {
                        childObj.rotation.x += (this.targetRotation.x - childObj.rotation.x) * childEasing;
                        childObj.rotation.y += (this.targetRotation.y - childObj.rotation.y) * childEasing;
                    }
                }
            },

            remove: function() {
                window.removeEventListener('mousemove', this.updateRotation); // Use bound function to remove event listener
            }
        });


        AFRAME.registerComponent('smooth-camera', {
            schema: {
                easing: { type: 'number', default: 0.1 }
            },

            init: function() {
                this.targetPosition = new THREE.Vector3();
                this.targetQuaternion = new THREE.Quaternion();
            },

            tick: function() {
                const easing = this.data.easing;
                const camera = this.el.getObject3D('camera');
                const children = this.el.children;

                if (!camera) return;

                // Get the target position and rotation from the camera's parent entity
                this.targetPosition.copy(this.el.object3D.position);
                this.targetQuaternion.copy(this.el.object3D.quaternion);

                // Calculate the eased position and rotation for the camera
                camera.position.lerp(this.targetPosition, easing);
                camera.quaternion.slerp(this.targetQuaternion, easing);

                // Ease the children’s position and rotation at half the speed of the camera
                const childEasing = easing / 2;
                for (let child of children) {
                    const childObj = child.object3D;
                    if (childObj) {
                        childObj.position.lerp(this.targetPosition, childEasing);
                        childObj.quaternion.slerp(this.targetQuaternion, childEasing);
                    }
                }
            }
        });

        AFRAME.registerComponent('start', {

            init: function() {
                // block pointer events until buttonEnter is clicked
                let uiDiv = document.getElementById("uiDiv");
                uiDiv.style["pointer-events"] = "auto";

                // set up background blocker
                uiDiv.style["background-color"] = "rgba(0, 0, 0, 1)";

                // indicate clickable with hand cursor (desktop)
                let buttonEnter = document.getElementById("buttonEnter");
                buttonEnter.style.cursor = "pointer";

                // fade-in functionality
                let fadeIn = function() {
                    // allow point events again
                    uiDiv.style["pointer-events"] = "none";

                    // sounds can only be triggered after a mouse interaction
                    let soundPlayer = document.querySelector("#ambientSound");
                    soundPlayer.components.sound.playSound();

                    // remove startButton
                    buttonEnter.parentNode.remove(buttonEnter);

                    // fade out uiDiv background
                    uiDiv.style["background-color"] = "rgba(0, 0, 0, 0.0)";
                    uiDiv.style["transition"] = "background-color 1000ms linear";
                }

                // activate for desktop/touchscreen
                buttonEnter.addEventListener('touchstart', fadeIn);
                buttonEnter.addEventListener('mousedown', fadeIn);
            }
        });

        AFRAME.registerComponent('edgeGlow', {
            schema: {
                color: { type: 'color', default: '#aaeeff' },
                fresnelExponent: { type: 'number', default: 1.0 },
                power: { type: 'number', default: 2.0 },
                outlineThickness: { type: 'number', default: 0.005 }, // Added
                outlineColor: { type: 'color', default: '#000000' } // Added
            },

            init: function() {
                const data = this.data;

                this.material = new THREE.ShaderMaterial({
                    uniforms: {
                        color: { type: 'c', value: new THREE.Color(data.color) },
                        fresnelExponent: { value: data.fresnelExponent },
                        power: { value: data.power },
                        outlineThickness: { value: data.outlineThickness }, // Added
                        outlineColor: { type: 'c', value: new THREE.Color(data.outlineColor) } // Added
                    },
                    vertexShader: `
                varying vec3 vViewPosition;
                varying vec3 vNormal;
                void main() {
                    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
                    gl_Position = projectionMatrix * mvPosition;
                    vViewPosition = -mvPosition.xyz;
                    vNormal = normalize(normalMatrix * normal); // Added
                }
            `,
                    fragmentShader: `
                uniform vec3 color;
                uniform float fresnelExponent;
                uniform float power;
                uniform float outlineThickness; // Added
                uniform vec3 outlineColor; // Added
                varying vec3 vViewPosition;
                varying vec3 vNormal; // Added
                void main() {
                    // Outline
                    float outline = 1.0 - smoothstep(1.0 - outlineThickness, 1.0, dot(vNormal, vec3(0.0, 0.0, 1.0)));
                    
                    // Fresnel Glow
                    vec3 viewDirectionW = normalize(vViewPosition);
                    float fresnelTerm = pow(1.0 - dot(viewDirectionW, vec3(0.0, 0.0, 1.0)), fresnelExponent);
                    vec3 finalColor = color * fresnelTerm * power;
                    
                    // Combine
                    vec3 mixedColor = mix(outlineColor * outline, finalColor, fresnelTerm);
                    gl_FragColor = vec4(mixedColor, max(outline, fresnelTerm));
                }
            `,
                    transparent: true,
                });

                this.el.addEventListener('model-loaded', () => {
                    this.applyMaterial();
                });
            },

            applyMaterial: function() {
                const mesh = this.el.getObject3D('mesh');
                if (mesh) {
                    mesh.material = this.material;
                }
            },
        });


        AFRAME.registerComponent('hover-opacity', {
            schema: {
                hoverOpacity: { type: 'number', default: 0.5 }
            },

            init: function() {
                const el = this.el;
                const data = this.data;

                // Function to set the opacity when hovered
                this.onMouseEnter = function() {
                    // Store the original opacity
                    el.setAttribute('data-original-opacity', el.getAttribute('material').opacity);
                    el.setAttribute('material', 'opacity', data.hoverOpacity);
                };

                // Function to reset the opacity when mouse leaves
                this.onMouseLeave = function() {
                    // Retrieve the original opacity and reset it
                    const originalOpacity = el.getAttribute('data-original-opacity');
                    el.setAttribute('material', 'opacity', originalOpacity);
                };

                el.addEventListener('mouseenter', this.onMouseEnter);
                el.addEventListener('mouseleave', this.onMouseLeave);
            },

            // Remove event listeners when the component is removed
            remove: function() {
                this.el.removeEventListener('mouseenter', this.onMouseEnter);
                this.el.removeEventListener('mouseleave', this.onMouseLeave);
            }
        });


        AFRAME.registerComponent('line-stack', {
            schema: {
                lineCount: { type: 'int', default: 11 }, // Number of lines
                lineSpacing: { type: 'number', default: 0.1 }, // Spacing between lines
                lineWidth: { type: 'number', default: 0.02 }, // Width of lines
                lineColor: { type: 'color', default: '#ffffff' }, // Line color
                rotationAngleY: { type: 'number', default: 0 }, // Rotation angle for motion
                fadeDuration: { type: 'number', default: 10 }, // Duration for fade in/out (in milliseconds)
                updateRotationY: { type: 'number', default: 0 }, // New property to track rotation based on external variable
            },

            init: function() {
                this.lines = []; // Array to store line entities
                // Create the stack of lines
                for (let i = 0; i < this.data.lineCount; i++) {
                    const yPos = (i - (this.data.lineCount - 1) / 2) * this.data.lineSpacing;
                    const line = document.createElement('a-entity');
                    line.setAttribute('line', {
                        start: `-${this.data.lineWidth / 2} ${yPos} 0`,
                        end: `${this.data.lineWidth / 2} ${yPos} 0`,
                        color: this.data.lineColor,
                        opacity: i === 0 ? 1 : 0, // Set opacity for the first line to 1, others to 0
                    });
                    this.lines.push(line);
                    this.el.appendChild(line);
                }

                // Set up an interval for cycling lines
                this.cycleInterval = setInterval(this.cycleLines.bind(this), this.data.fadeDuration);
            },

            update: function(oldData) {
                // Check if the updateRotationY property has changed
                if (this.data.updateRotationX !== oldData.updateRotationX) {
                    // Update the rotation angle based on the new value
                    this.data.rotationAngleX = this.data.updateRotationX;

                    // Call the method to update line positions
                    this.updateLinePositions();
                }
            },

            updateLinePositions: function() {
                console.log('rotation Triggered');
                // Calculate the yOffset based on the rotationAngleY
                const yOffset = this.rotationAngleX * this.data.lineSpacing * 0.5;

                // Move each line up and down based on the yOffset
                for (let i = 0; i < this.lines.length; i++) {
                    const line = this.lines[i];
                    const yPos = (i - (this.data.lineCount - 1) / 2) * this.data.lineSpacing + yOffset;
                    line.setAttribute('line', {
                        start: `-${this.data.lineWidth / 2} ${yPos} 0`,
                        end: `${this.data.lineWidth / 2} ${yPos} 0`,
                    });
                }
            },

            cycleLines: function() {
                // Fade out the bottom line and fade in the top line
                const bottomLine = this.lines[0];
                const topLine = this.lines[this.data.lineCount - 1];

                // Fade out the bottom line
                bottomLine.setAttribute('animation__fadeout', {
                    property: 'components.line.material.opacity',
                    to: 1,
                    dur: this.data.fadeDuration,
                    easing: 'linear',
                });

                // Fade in the top line
                topLine.setAttribute('animation__fadein', {
                    property: 'components.line.material.opacity',
                    to: 1,
                    dur: this.data.fadeDuration,
                    easing: 'linear',
                });

                // Move the bottom line to the top and reset its opacity
                this.lines.shift();
                this.lines.push(bottomLine);
                bottomLine.setAttribute('line', { opacity: 1 });
            },

            remove: function() {
                // Clear the cycleInterval when the component is removed
                clearInterval(this.cycleInterval);
            },
        });


        AFRAME.registerComponent('rotation-reader', {
            tick: function() {
                // `this.el` is the element.
                // `object3D` is the three.js object.

                // Get the rotation as a three.js Euler using radians.
                const rotation = this.el.object3D.rotation;

                // Calculate and log the angle in degrees based on the y-axis rotation.
                const angleInDegreesY = THREE.MathUtils.radToDeg(rotation.y);
                this.rotationAngleY = angleInDegreesY;
                window.globalRotationAngleY = angleInDegreesY;

                //console.log('Angle in degrees Y:', this.rotationAngleY);

                const angleInDegreesX = THREE.MathUtils.radToDeg(rotation.x);
                this.rotationAngleX = angleInDegreesX;
                this.el.emit('rotation-updated', { rotationAngleX: this.rotationAngleX });
                //console.log('Angle in degrees X:', this.rotationAngleX);

                // `position` is a three.js Vector3.
                //console.log('Position:', this.el.object3D.position);
                this.el.emit('rotation-updated', {
                    rotationAngleY: this.rotationAngleY,
                    rotationAngleX: this.rotationAngleX,
                });

            }
        });
        const animate = () => {
            this.rotateCursorBound();
            this.moveBoxLeftBound();
            this.moveBoxRightBound();
            this.updateRtcBound();
            requestAnimationFrame(animate);
        };
        animate();
        const sceneEl = document.querySelector('a-scene');


        setInterval(this.rotateCursor, 50); // Update rotation every 10 milliseconds   
        setInterval(this.moveBoxLeft, 50); // Update rotation every 10 milliseconds   
        setInterval(this.moveBoxRight, 50); // Update rotation every 10 milliseconds   

        sceneEl.addEventListener('rotation-updated', (event) => {
            // Update the rotationAngleY and rotationAngleX properties when the event is received
            this.rotationAngleY = event.detail.rotationAngleY;
            this.rotationAngleX = event.detail.rotationAngleX;
        });

        // Get the raycaster component
        const raycaster = this.$el.querySelector('[raycaster]');

        // Set the ignore property to select elements with the "ignored" class
        raycaster.setAttribute('raycaster', 'ignore', '.ignored');

        let labelScript = document.createElement('script')
        labelScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/aframe-label@0.1.0/index.min.js')
        document.head.appendChild(labelScript)



        setInterval(this.updateRtc, 1000); // Update rotation every 10 milliseconds

        const refElement = this.$refs.noclipMainDesc; // assuming you've set "ref='myRefElement'" on your HTML element
        this.animateText('DECENTRALIZED ACCESS TO ORBITAL INFRASTRUCTURE', refElement, 2, 2000);


        const refElement2 = this.$refs.noclipMainTitle; // assuming you've set "ref='myRefElement'" on your HTML element
        this.animateText('NOCLIP', refElement2, 20, 0);


        const refElement3 = this.$refs.noclipSecondaryDesc; // assuming you've set "ref='myRefElement'" on your HTML element
        this.animateText('THE OVERIVEW EFFECT FOR EVERYONE', refElement3, 1, 1000);
        this.generateHeatmapData(300);
    },
    beforeUnmount() {
        // Remove the resize event listener when the component is unmounted



        window.removeEventListener('resize', this.adjustSceneSize);
        window.removeEventListener('resize', this.adjustSceneSizeBound);
        this.$el.removeEventListener('superkeyboarddismiss', this.dismissKeyboardBound);
    },
    methods: {
        resetCameraX() {
            this.cameraPosition.x = 0;
        },

        generateHeatmapData(numPoints) {
            console.log('HEATMAP');
            // Gen random data
            const gData = [...Array(numPoints).keys()].map(() => ({
                lat: (Math.random() - 0.5) * 160,
                lng: (Math.random() - 0.5) * 360,
                weight: Math.random()
            }));

            // Make sure the A-Frame scene is loaded before setting attributes
            const globeEntity = document.getElementById('globe2');
            if (globeEntity) {
                globeEntity.setAttribute('globe2', {
                    heatmapsData: [gData],
                    heatmapPointLat: 'lat',
                    heatmapPointLng: 'lng',
                    heatmapPointWeight: 'weight',
                    heatmapTopAltitude: 70,
                    heatmapsTransitionDuration: 3000
                });
                console.log('HEAT GENERATED');

            }
        },
        generateArcsData(N) {
            console.log('ARCS');

            // Gen random data
            const arcsData = [...Array(N).keys()].map(() => ({
                startLat: (Math.random() - 0.5) * 180,
                startLng: (Math.random() - 0.5) * 360,
                endLat: (Math.random() - 0.5) * 180,
                endLng: (Math.random() - 0.5) * 360,
                color: [
                    ['red', 'white', 'blue', 'green'][Math.round(Math.random() * 3)],
                    ['red', 'white', 'blue', 'green'][Math.round(Math.random() * 3)]
                ]
            }));

            // Make sure the A-Frame scene is loaded before setting attributes
            const globeEntity = document.getElementById('globe2');
            if (globeEntity) {
                globeEntity.setAttribute('globe2', {
                    arcsData: arcsData,
                    arcColor: 'color',
                    arcDashLength: () => Math.random(),
                    arcDashGap: () => Math.random(),
                    arcDashAnimateTime: () => Math.random() * 4000 + 500
                });
                console.log('ARCS GENERATED');

            }

        },
        handleScrollEvent(event) {
            clearTimeout(this.snapTimeout);

            let deltaY;

            if (event.type === 'wheel') {
                deltaY = event.deltaY;
            } else if (event.type === 'touchmove') {
                const touchEndY = event.changedTouches[0].clientY;
                deltaY = touchEndY - this.touchStartY;
                this.touchStartY = touchEndY; // Update touchStartY for continuous swiping
            }

            if (deltaY > 0) {
                // Mouse wheel moved DOWN or Swipe DOWN
                this.wheelcount++;
                this.rightValue = 100 - this.wheelcount * 2;

                this.processMovement('down');
            } else {
                // Mouse wheel moved UP or Swipe UP
                this.wheelcount--;
                this.rightValue = 100 - this.wheelcount * 2;

                this.processMovement('up');
            }


            this.snapTimeout = setTimeout(() => {
                if (deltaY > 0) {
                    this.initiateSnap('down');
                } else {
                    this.initiateSnap('up');
                }
            }, 200);

            // Prevent default browser scroll
            event.preventDefault();
        },


        handleTouchStart(event) {
            this.touchStartY = event.touches[0].clientY;
        },

        initiateSnap(direction) {
            // Calculate target value based on where the current wheelcount is and the direction of movement
            let targetValue;

            if (direction === 'up') {
                targetValue = this.wheelcount - (this.wheelcount % 10);
            } else {
                targetValue = this.wheelcount + (10 - (this.wheelcount % 10));
            }

            this.snapAnimation(targetValue);
        },


        snapAnimation(target) {
            if (this.wheelcount < target) {
                this.wheelcount++;
                this.rightValue = 100 - this.wheelcount * 2; // Increase by 10% for every scroll up or swipe up

            } else if (this.wheelcount > target) {
                this.wheelcount--;
                this.rightValue = 100 - this.wheelcount * 2; // Increase by 10% for every scroll up or swipe up

            } else {
                // If we've reached the target, stop the animation
                return;
            }

            // If we're not at the target yet, continue the animation
            requestAnimationFrame(() => this.snapAnimation(target));
        },

        processScrollBuffer() {
            // Check the buffer to determine the action direction
            if (this.scrollBuffer > 0) {
                // Mouse wheel moved DOWN
                this.wheelcount += 0;
                this.processMovement('down');
            } else {
                // Mouse wheel moved UP
                this.wheelcount -= 0;
                this.processMovement('up');
            }

            // Reset buffer for next scroll sequence
            this.scrollBuffer = 0;
        },
        handleTouchMove(event) {
            const touchX = event.touches[0].clientX;
            const touchY = event.touches[0].clientY;

            const deltaX = touchX - this.startX;
            const deltaY = touchY - this.startY;

            // Handle left and right swipes
            if (deltaX > 50) {
                this.processMovement('up'); // Swipe right treated as 'up'
            } else if (deltaX < -50) {
                this.processMovement('down'); // Swipe left treated as 'down'
            }

            // Handle up and down swipes
            if (deltaY > 50) {
                this.processMovement('down'); // Regular swipe down
            } else if (deltaY < -50) {
                this.processMovement('up'); // Regular swipe up
            }
        },


        handleSwipeUp() {
            this.processMovement('up');
        },

        handleSwipeDown() {
            this.processMovement('down');
        },
        introRender(truth) {

            if (truth == true) {
                this.timescale = 1;
                this.startOverviewEffect({ x: 20, y: 0, z: this.wheelcount / 8 }, { x: -30, y: 20, z: -90 }, 2000);

                const refElement = this.$refs.noclipMainDesc;
                this.animateText('DECENTRALIZED ACCESS TO ORBITAL INFRASTRUCTURE', refElement, 1, 2);

                const refElement2 = this.$refs.noclipMainTitle;
                this.animateText('NOCLIP', refElement2, 20, 0);

                const refElement3 = this.$refs.noclipSecondaryDesc;
                this.animateText('THE OVERIVEW EFFECT FOR EVERYONE', refElement3, 1, 1);
            } else {
                return
            }
        },
        processMovement(direction) {
            if (direction === 'down') {
                // Logic related to wheel moving DOWN or touch swipe DOWN
                //this.wheelcount = this.wheelcount + 1;
                this.playChirp(20, 0.1, 0.01);
                console.log(`Accumulated ${this.wheelcount} units`);



                if (this.wheelcount < 50) {
                    this.startOverviewEffect({ x: this.wheelcount / 5, y: 0, z: 0 }, { x: this.wheelcount / 5, y: this.wheelcount * 2, z: -90 }, 2000);
                }



                if (this.wheelcount == 50) {
                    this.playChirp(1500, 0.1, 0.01);
                }

                if (this.wheelcount >= 50 && this.wheelcount <= 110) {
                    const chirpMap = {
                        60: 2000,
                        70: 2500,
                        80: 3000,
                        90: 3500,
                        100: 4000
                    };
                    this.startOverviewEffect({ x: 20, y: 0, z: this.wheelcount / 8 }, { x: -30, y: 20, z: 40 }, 2000);

                    if (chirpMap[this.wheelcount]) {
                        this.playChirp(chirpMap[this.wheelcount], 0.1, 0.01);
                    }
                }

                if (this.wheelcount >= 51) {
                    this.showIntro = false;
                    this.showAbout = true;
                    if (this.wheelcount <= 61) {
                        this.timescale = 1000;
                        this.startOverviewEffect({ x: 20, y: 0, z: this.wheelcount / 8 }, { x: -30, y: 20, z: -90 }, 2000);
                    }
                }
                if (this.wheelcount >= 130) {
                    this.wheelcount = 130;
                }

            } else if (direction === 'up') {
                // Logic related to wheel moving UP or touch swipe UP
                //this.wheelcount = this.wheelcount - 1;
                if (this.wheelcount <= 0) {
                    this.wheelcount = 0;
                }
                this.playChirp(40, 0.1, 0.01);
                console.log(`Accumulated ${this.wheelcount} units`);


                if (this.wheelcount < 50) {
                    this.startOverviewEffect({ x: this.wheelcount / 5, y: 0, z: 0 }, { x: this.wheelcount / 5, y: this.wheelcount * 2, z: -90 }, 2000);
                }

                if (this.wheelcount < 60) {
                    this.showIntro = true;
                    this.showAbout = false;
                    if (this.wheelcount >= 50) {
                        this.introRender(true);
                    }
                }

                if (this.wheelcount >= 50 && this.wheelcount <= 110) {
                    const chirpMap = {
                        60: 2000,
                        70: 2500,
                        80: 3000,
                        90: 3500,
                        100: 4000
                    };
                    this.startOverviewEffect({ x: 20, y: 0, z: this.wheelcount / 8 }, { x: -30, y: 20, z: 40 }, 2000);

                    if (chirpMap[this.wheelcount]) {
                        this.playChirp(chirpMap[this.wheelcount], 0.1, 0.01);
                    }
                }
                if (this.wheelcount >= 120) {
                    this.startOverviewEffect({ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 }, 2000);
                }
                if (this.wheelcount >= 130) {
                    this.wheelcount = 130;
                }
            }
        },
        /*
                handleEvent(event) {
                    let deltaY = 0;

                    if (event.type === 'wheel') {
                        deltaY = event.deltaY;
                    } else if (event.type === 'touchmove') {
                        const touchEndY = event.changedTouches[0].clientY;
                        deltaY = touchEndY - this.touchStartY;
                        this.touchStartY = touchEndY; // Update touchStartY for continuous swiping
                    }

                    this.deltaCounter += deltaY;

                    if (this.deltaCounter >= this.snapThreshold) {
                        this.deltaCounter = 0;
                        // Snap forward logic
                        console.log('Snap forward');
                    } else if (this.deltaCounter <= -this.snapThreshold) {
                        this.deltaCounter = 0;
                        // Snap backward logic
                        console.log('Snap backward');
                    }

                    event.preventDefault(); // Prevent any default behavior
                },

                handleTouchStart(event) {
                    this.touchStartY = event.touches[0].clientY;
                },

                
                        //hybrid prototype
                        handleEvent(event) {
                            let deltaY = 0;

                            if (event.type === 'wheel') {
                                deltaY = event.deltaY;
                            } else if (event.type === 'touchmove') {
                                const touchEndY = event.changedTouches[0].clientY;
                                deltaY = touchEndY - this.touchStartY;
                                this.touchStartY = touchEndY; // update touchStartY for continuous swiping
                            }

                            this.deltaCounter += deltaY;

                            if (this.deltaCounter >= 10) {
                                this.deltaCounter = 0;
                                // Snap forward logic
                                console.log('Snap forward');
                            } else if (this.deltaCounter <= -10) {
                                this.deltaCounter = 0;
                                // Snap backward logic
                                console.log('Snap backward');
                            }
                        },

                        handleTouchStart(event) {
                            this.touchStartY = event.touches[0].clientY;
                        },
                







                //mouse wheel handling


                handleWheel(event) {
                    const unitsMoved = event.deltaY;

                    if (unitsMoved > 0) {
                        console.log(`Mouse wheel moved DOWN by ${unitsMoved} units`);
                        this.wheelcount = this.wheelcount + 1;
                        this.playChirp(20, 0.1, 0.01);

                        console.log(`Accumulated ${this.wheelcount} units`);
                        if (this.rightValue >= 0) {
                            this.rightValue = this.rightValue - 2; // Increase by 10% for every scroll down     
                        }
                        if (this.wheelcount == 50) {
                            this.playChirp(1500, 0.1, 0.01);

                        }
                        if (this.wheelcount >= 50 && this.wheelcount <= 110) {
                            if (this.wheelcount == 60) {
                                this.playChirp(2000, 0.1, 0.01);
                            }
                            if (this.wheelcount == 70) {
                                this.playChirp(2500, 0.1, 0.01);
                            }
                            if (this.wheelcount == 80) {
                                this.playChirp(3000, 0.1, 0.01);
                            }
                            if (this.wheelcount == 90) {
                                this.playChirp(3500, 0.1, 0.01);
                            }
                            if (this.wheelcount == 100) {
                                this.playChirp(4000, 0.1, 0.01);
                            }

                        }

                        if (this.wheelcount >= 50) {
                            this.showIntro = false;
                            this.showAbout = true;
                            if (this.wheelcount <= 52) {

                                this.startOverviewEffect({ x: 20, y: -5, z: 5 }, { x: -30, y: 20, z: -90 }, 2000);

                            }
                        }
                    } else {
                        console.log(`Mouse wheel moved UP by ${Math.abs(unitsMoved)} units`);
                        this.wheelcount = this.wheelcount - 1;
                        if (this.wheelcount <= 0) {
                            this.wheelcount = 0
                        }
                        this.playChirp(40, 0.1, 0.01);
                        console.log(`Accumulated ${this.wheelcount} units`);
                        if (this.rightValue <= 100) {
                            this.rightValue = this.rightValue + 2; // Increase by 10% for every scroll down     
                        }

                        if (this.wheelcount <= 49) {
                            this.showIntro = true;
                            this.showAbout = false;

                            if (this.showIntro == true && this.wheelcount >= 47) {
                                this.startOverviewEffect({ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: -90 }, 2000);

                                const refElement = this.$refs.noclipMainDesc; // assuming you've set "ref='myRefElement'" on your HTML element
                                this.animateText('DECENTRALIZED ACCESS TO ORBITAL INFRASTRUCTURE', refElement, 1, 2);


                                const refElement2 = this.$refs.noclipMainTitle; // assuming you've set "ref='myRefElement'" on your HTML element
                                this.animateText('NOCLIP', refElement2, 20, 0);


                                const refElement3 = this.$refs.noclipSecondaryDesc; // assuming you've set "ref='myRefElement'" on your HTML element
                                this.animateText('THE OVERIVEW EFFECT FOR EVERYONE', refElement3, 1, 1);
                            }
                        }
                        if (this.wheelcount >= 50 && this.wheelcount <= 110) {
                            if (this.wheelcount == 60) {
                                this.playChirp(2000, 0.1, 0.01);
                            }
                            if (this.wheelcount == 70) {
                                this.playChirp(2500, 0.1, 0.01);
                            }
                            if (this.wheelcount == 80) {
                                this.playChirp(3000, 0.1, 0.01);
                            }
                            if (this.wheelcount == 90) {
                                this.playChirp(3500, 0.1, 0.01);
                            }
                            if (this.wheelcount == 100) {
                                this.playChirp(4000, 0.1, 0.01);
                            }

                        }


                    }

                    // If you want to prevent the default browser scroll behavior (if any):
                    event.preventDefault();
                },


                
                        
                        handleTouchStart(event) {
                            this.startY = event.touches[0].clientY; // store the Y position of the touch
                        },

                


                //touch event handling old
                handleTouchMove(event) {
                    const touchY = event.touches[0].clientY;
                    const deltaY = touchY - this.startY;

                    if (deltaY > 50) { // swipe down detected
                        this.handleSwipeDown();
                    } else if (deltaY < -50) { // swipe up detected
                        this.handleSwipeUp();
                    }
                },

                handleSwipeUp() {
                    console.log(`Swipe UP detected`);
                    this.wheelcount = this.wheelcount - 1;
                    if (this.wheelcount <= 0) {
                        this.wheelcount = 0;
                    }
                    this.playChirp(40, 0.1, 0.01);
                    console.log(`Accumulated ${this.wheelcount} units`);
                    if (this.rightValue <= 50) {
                        this.rightValue = this.rightValue + 2; // Increase by 10% for every swipe up
                    }

                    if (this.wheelcount <= 50) {
                        this.showIntro = true;
                        this.showAbout = false;

                        if (this.showIntro == true && this.wheelcount >= 48) {
                            this.startOverviewEffect({ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: -90 }, 2000);
                            const refElement = this.$refs.noclipMainDesc;
                            this.animateText('DECENTRALIZED ACCESS TO ORBITAL INFRASTRUCTURE', refElement, 1, 2);

                            const refElement2 = this.$refs.noclipMainTitle;
                            this.animateText('NOCLIP', refElement2, 20, 0);

                            const refElement3 = this.$refs.noclipSecondaryDesc;
                            this.animateText('THE OVERIVEW EFFECT FOR EVERYONE', refElement3, 1, 1);
                        }
                    }
                },

                handleSwipeDown() {
                    console.log(`Swipe DOWN detected`);
                    this.wheelcount = this.wheelcount + 1;
                    this.playChirp(20, 0.1, 0.01);
                    console.log(`Accumulated ${this.wheelcount} units`);
                    if (this.rightValue >= 0) {
                        this.rightValue = this.rightValue - 1; // Increase by 10% for every swipe down     
                    }
                    if (this.wheelcount == 50) {
                        this.playChirp(2000, 0.1, 0.01);
                    }

                    if (this.wheelcount >= 50) {
                        this.showIntro = false;
                        this.showAbout = true;

                        if (this.wheelcount <= 50) {
                            this.startOverviewEffect({ x: 20, y: -5, z: 5 }, { x: -30, y: 20, z: -90 }, 2000);
                        }

                    }
                    if (this.wheelcount >= 50 && this.wheelcount <= 110) {
                        if (this.wheelcount == 60) {
                            this.playChirp(2000, 0.1, 0.01);
                        }
                        if (this.wheelcount == 70) {
                            this.playChirp(2500, 0.1, 0.01);
                        }
                        if (this.wheelcount == 80) {
                            this.playChirp(3000, 0.1, 0.01);
                        }
                        if (this.wheelcount == 90) {
                            this.playChirp(3500, 0.1, 0.01);
                        }
                        if (this.wheelcount == 100) {
                            this.playChirp(4000, 0.1, 0.01);
                        }

                    }
                },

        */


        //parallax motion toward mouse on mouse move

        moveLogo(event) {
            // Get the width and height of the screen
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;

            // Calculate the normalized values
            const normalizedX = (event.clientX / screenWidth) * 2 - 1;
            const normalizedY = (event.clientY / screenHeight) * 2 - 1;
            // Map the normalized values to the range of -20deg to +20deg
            const mappedX = normalizedX * 20;
            const mappedY = normalizedY * -10;

            // Set the logoX and logoY values
            this.logoX = `${mappedX}deg`;
            this.logoY = `${mappedY}deg`;
            this.logoXr = `${mappedX}px`;
            this.logoYr = `${mappedY}px`;
            this.logoX2 = `${normalizedX}deg`;
            this.logoY2 = `${normalizedY * -1}deg`;
            this.logoXx = (normalizedX).toFixed(4);
            this.logoYy = (normalizedY).toFixed(4);
        },
        afterLeave() {
            // Any code to run after the animation completes can be put here.
            // Currently, it's empty, but it's here for demonstration purposes.
        },

        loadAframeSceneWithDelay() {
            const aframeScene = this.$refs.scene;

            // Initially hide the scene
            aframeScene.style.display = 'none';

            setTimeout(() => {
                aframeScene.style.display = 'block';
                aframeScene.style.opacity = '1'
                aframeScene.style.animation = 'fadein 5s ease 1';
            }, 5000); // 2 seconds delay, adjust as needed
        },

        randomChar() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            return chars[Math.floor(Math.random() * chars.length)];

        },

        type(finaltext, index, refElement, timing) {
            if (index === finaltext.length) {
                this.finished = true;
                return;
            }

            let text = finaltext.substr(0, index);
            text = text.replace(/./g, '<span >$&</span>');
            for (let i = 0; i < 5; i++) {
                setTimeout(() => {
                    this.playChirp(16000, 0.005, 0.005);
                    refElement.innerHTML = text + '<span>' + this.randomChar() + '</span>' + finaltext.substr(index + 1).replace(/./g, '<span style="color: transparent;">$&</span>');
                }, i * timing);
            }

            setTimeout(() => {
                refElement.innerHTML = finaltext.substr(0, index + 1).replace(/./g, '<span>$&</span>') +
                    finaltext.substr(index + 1).replace(/./g, '<span style="color: transparent;">$&</span>');
                this.type(finaltext, index + 1, refElement, timing);
            }, 5 * timing);
        },

        animateText(finaltext, refElement, timing = 80, delayStart = 0) {
            setTimeout(() => {
                this.type(finaltext, 0, refElement, timing);
            }, delayStart);
        },

        async fetchIpAddress() {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                this.ipAddress = data.ip;
            } catch (error) {
                console.error("Error fetching IP:", error);
            }
        },
        goToURL(url) {
            window.location.href = url;
        },
        prettyBalance(bal) {
            return parseFloat(ethers.utils.formatEther(bal)).toFixed(4);
        },
        simpleBalance(bal2) {
            return parseFloat(ethers.utils.formatEther(bal2)).toFixed(1);
        },
        condenseBalance(bal3) {
            return parseFloat(bal3).toFixed(0);
        },
        async dispatchPurchase() {
            const value = ethers.utils.parseEther(this.value).div(this.pricePerEth);
            this.purchase({ value });
        },
        topDialOnMouseDown() {
            const cameraEl = document.getElementById('camera');
            cameraEl.setAttribute('look-controls', 'enabled', false);

            window.addEventListener('mousemove', this.topDialOnMouseMove);
            window.addEventListener('mouseup', this.topDialOnMouseUp);
        },

        topDialOnMouseUp() {
            const cameraEl = document.getElementById('camera');
            cameraEl.setAttribute('look-controls', 'enabled', true);

            window.removeEventListener('mousemove', this.topDialOnMouseMove);
            window.removeEventListener('mouseup', this.topDialOnMouseUp);
        },

        topDialOnMouseMove(e) {
            const centerX = window.innerWidth / 2;

            const dx = e.clientX - centerX;
            let angle = Math.abs((dx / (window.innerWidth / 2)) * 60);
            angle = Math.max(0, Math.min(45, angle)) * -1;

            if (e.clientX > centerX) {
                angle = -angle;
            }

            if (!this.chirpInProgress) {
                //this.playChirp(8000, 0.1, 0.005);
                this.chirpInProgress = true;
                setTimeout(() => this.chirpInProgress = false, 5);
            }

            this.timescale = Math.abs(angle) + 1;

            this.topDialRotation = `0 0 ${angle.toFixed(2)}`;
            this.topDialRotationInv = `0 0 ${-angle.toFixed(2)}`; // Assuming you want the inverse rotation, you can adjust it accordingly
        },



        created() {
            // Use lodash to create a throttled version of the mouse move handler
            this.topDialOnMouseDown = this.topDialOnMouseDown.bind(this);
            this.topDialOnMouseUp = this.topDialOnMouseUp.bind(this);
            this.topDialOnMouseMove = _.throttle(this.topDialOnMouseMove.bind(this), 16);
        },

        enableLookControls() {
            const camera = document.getElementById("#camera");
            const camera1 = document.getElementById("#camera1");
            // To enable look controls
            camera1.setAttribute('camera', 'active', false);
            camera.setAttribute('camera', 'active', true);
            console.log('switched cameras');
        },

        startOverviewEffect(endPosition, endRotation, duration) {
            //this.playChirp(3000, 0.1, 0.2);

            const camera = this.$refs.camera;
            const startPosition = camera.getAttribute('position');
            const startRotation = camera.getAttribute('rotation');

            duration = parseInt(duration);
            if (isNaN(duration) || duration <= 0) {
                duration = 1000;
            }

            const startTime = performance.now();

            // Ease-in-out cubic function
            const easeInOutCubic = (t) => {
                return t < 0.5 ?
                    4 * t * t * t :
                    (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            };

            const animateCameraPositionAndRotation = (time) => {
                const elapsed = time - startTime;
                let fraction = Math.min(elapsed / duration, 1);

                // Apply the easing function to the fraction
                fraction = easeInOutCubic(fraction);

                const x = startPosition.x + (endPosition.x - startPosition.x) * fraction;
                const y = startPosition.y + (endPosition.y - startPosition.y) * fraction;
                const z = startPosition.z + (endPosition.z - startPosition.z) * fraction;

                const xr = startRotation.x + (endRotation.x - startRotation.x) * fraction;
                const yr = startRotation.y + (endRotation.y - startRotation.y) * fraction;
                const zr = startRotation.z + (endRotation.z - startRotation.z) * fraction;

                camera.setAttribute('position', { x, y, z });
                camera.setAttribute('rotation', { x: xr, y: yr, z: zr });

                if (fraction < 1) {
                    requestAnimationFrame(animateCameraPositionAndRotation);
                }
            };

            requestAnimationFrame(animateCameraPositionAndRotation);
        },
        getUserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.latitude = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                }, (error) => {
                    console.error("Error getting location:", error);
                });
            } else {
                console.error("Geolocation is not supported by this browser.");
            }
        },

        loadScript() {
            // Load your script dynamically
            const script1 = document.createElement('script');
            script1.src = '//unpkg.com/satellite.js/dist/satellite.min.js';
            script1.async = true;
            script1.onload = () => {
                // Script loaded successfully
            };

            const script = document.createElement('script');
            script.src = 'satellite-load.js';
            script.async = true;
            script.onload = () => {
                // Script loaded successfully
            };


            // Append the script to the document's body
            document.body.appendChild(script1);
            // Append the script to the document's body
            document.body.appendChild(script);
        },
        randomPaths() { // Gen random paths
            const N_PATHS = 10;
            const MAX_POINTS_PER_LINE = 10000;
            const MAX_STEP_DEG = 1;
            const MAX_STEP_ALT = 0.015;
            const gData = [...Array(N_PATHS).keys()].map(() => {
                let lat = (Math.random() - 0.5) * 90;
                let lng = (Math.random() - 0.5) * 360;
                let alt = 0;

                return [
                    [lat, lng, alt], ...[...Array(Math.round(Math.random() * MAX_POINTS_PER_LINE)).keys()].map(() => {
                        lat += (Math.random() * 2 - 1) * MAX_STEP_DEG;
                        lng += (Math.random() * 2 - 1) * MAX_STEP_DEG;
                        alt += (Math.random() * 2 - 1) * MAX_STEP_ALT;
                        alt = Math.max(0, alt);

                        return [lat, lng, alt];
                    })
                ];
            });

            const globeEntity = document.getElementById('globe2');
            globeEntity.setAttribute('globe2', {
                pathsData: gData,
                pathColor: () => ['rgba(0,0,255,0.6)', 'rgba(255,0,0,0.6)'],
                pathDashLength: 0.01,
                pathDashGap: 0.004,
                pathDashAnimateTime: 100000
            });

            setTimeout(() => {
                globeEntity.setAttribute('globe2', {
                    pathPointAlt: pnt => pnt[2], // set altitude accessor
                    pathTransitionDuration: 4000
                });
            }, 6000);
        },
        calculateLeftComplication() {
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;
            if (this.isDesktop()) {

                // Calculate the desired x position as a proportion of screen height to screen width
                const desiredXPosition = -0.6 / (screenHeight / screenWidth);

                return { x: desiredXPosition, y: 0, z: -1 };
            } else {
                // Calculate the desired x position as a proportion of screen height to screen width
                const desiredXPosition = -1.6 / (screenHeight / screenWidth);

                return { x: desiredXPosition, y: 0, z: -2 };
            }
        },
        calculateRightComplication() {
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;
            if (this.isDesktop()) {

                // Calculate the desired x position as a proportion of screen height to screen width
                const desiredYPosition = 0.6 / (screenHeight / screenWidth);

                return { x: desiredYPosition, y: 0, z: -1 };
            } else {
                // Calculate the desired x position as a proportion of screen height to screen width
                const desiredYPosition = 1.6 / (screenHeight / screenWidth);

                return { x: desiredYPosition, y: 0, z: -2 };
            }

        },
        moveBoxLeft() {
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;

            const rotL = this.rotationAngleX * 0.01;

            if (this.isDesktop()) {

                this.boxPositionLeft = { x: (-0.6 - this.zPosition) / (screenHeight / screenWidth), y: rotL, z: -1 };

            } else {
                this.boxPositionLeft = { x: (-1.6 - this.zPosition) / (screenHeight / screenWidth), y: rotL, z: -2 };

            }





            // Update the lastRotationAngleX to the current value
            this.lastRotationAngleX = this.rotationAngleX;
        },
        moveBoxRight() {
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;

            if (this.rotationAngleY >= 180) {
                this.rotationAngleY == this.rotationAngleY - this.rotationAngleY;

                return this.rotationAngleY;

            }
            if (this.rotationAngleY <= -180) {
                this.rotationAngleY == this.rotationAngleY + this.rotationAngleY;
                return this.rotationAngleY;
            }
            const rotR = this.rotationAngleY * 0.01;

            if (this.isDesktop()) {

                this.boxPositionRight = { x: (0.6 + this.zPosition) / (screenHeight / screenWidth), y: rotR, z: -1 };

            } else {
                this.boxPositionRight = { x: (1.6 + this.zPosition) / (screenHeight / screenWidth), y: rotR, z: -2 };

            }


            // Update the lastRotationAngleY to the current value
            this.lastRotationAngleY = this.rotationAngleY;
        },
        rotateCursor() {

            const rotC = this.rotationAngleY;


            this.cursorRotation = { x: 0, y: 0, z: rotC };
            if (this.rotationAngleY !== this.lastRotationAngleY) {
                if (!this.chirpInProgress) {
                    // Chirp is not in progress, play the chirp sound
                    //this.playChirp(
                    // 18000 + parseFloat(this.rotationAngleY).toFixed(2) * 10,
                    // 0.1,
                    //   0.1
                    //  );

                    // Set the flag to indicate that a chirp is in progress
                    this.chirpInProgress = true;

                    // Set a timeout to reset the chirp status after 50 milliseconds
                    setTimeout(() => {
                        this.chirpInProgress = false;
                    }, 100);
                }
            }

            // Update the lastRotationAngleY to the current value
            this.lastRotationAngleY = this.rotationAngleY;
        },
        adjustFOVAndZPosition(event) {
            if (event.deltaY < 0) {
                this.fov = Math.max(this.fov - 1, 90);
            } else {
                this.fov = Math.min(this.fov + 1, 90);
            }
            this.zPosition = this.mapRange(this.fov, 90, 90, 0.4, -0.4);
            requestAnimationFrame(() => console.log('Adjusted FOV:', this.fov, 'Z Position:', this.zPosition));
        },


        mapRange(value, inMin, inMax, outMin, outMax) {
            return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
        },
        progs() {
            this.keyboardOutput = null;
            this.prog++;
            console.log(this.prog);
            this.cursor = false;
            if (this.prog == 4) {
                this.prog = 1;
            }
        },

        efficientSwap(status) {
            let isToggled = status;

            isToggled = !isToggled; // Toggle the state
            this.efficient = isToggled;
            console.log('Toggled state is now:', isToggled); // Log the current state
        },
        dismissKeyboard() {
            // Handle the 'superkeyboarddismiss' event
            this.cursor = true; // Set 'keyboard' to false to dismiss the keyboard
            if (this.prog == 1) {
                this.keyboardOutputTitle = this.keyboardOutput;
            }
            if (this.prog == 2) {
                this.keyboardOutputDesc = this.keyboardOutput;
            }
            if (this.prog == 3) {
                this.keyboardOutputLink = this.keyboardOutput;
            }
            console.log(this.cursor);
        },
        visitLink(url) {
            if (typeof url === 'string' && url.length > 0) {
                // Open the URL in a new tab or window
                window.open(url, '_blank');
            } else {
                console.error('Invalid URL provided');
            }
        },

        adjustSceneSize() {
            const aframeScene = this.$refs.scene;

            // Get the current viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            // Set the A-Frame scene's dimensions to match the viewport
            aframeScene.setAttribute('width', viewportWidth);
            aframeScene.setAttribute('height', viewportHeight);
        },

        isDesktop() {
            // Use a media query to check screen width
            return window.matchMedia("(min-width: 1024px)").matches;
        },

        isMobile() {
            // Use a media query to check screen width
            return window.matchMedia("(max-width: 1024px)").matches;
        },


        randomArcs() { // Gen random data
            const N = 20;
            const arcsData = [...Array(N).keys()].map(() => ({
                startLat: (Math.random() - 0.5) * 180,
                startLng: (Math.random() - 0.5) * 360,
                endLat: (Math.random() - 0.5) * 180,
                endLng: (Math.random() - 0.5) * 360,
                color: [
                    ['red', 'white', 'blue', 'green'][Math.round(Math.random() * 3)],
                    ['red', 'white', 'blue', 'green'][Math.round(Math.random() * 3)]
                ]
            }));

            const globeEntity = document.getElementById('globe2');
            globeEntity.setAttribute('globe2', {
                arcsData: arcsData,
                arcColor: 'color',
                arcDashLength: () => Math.random(),
                arcDashGap: () => Math.random(),
                arcDashAnimateTime: () => Math.random() * 4000 + 500
            });
        },
        popMap() {
            const weightColor = d3.scaleSequentialSqrt(d3.interpolateYlOrRd)
                .domain([0, 1e7]);

            const globeEntity = document.getElementById('globe2');
            globeEntity.setAttribute('globe', {
                hexBinPointWeight: 'pop',
                hexAltitude: d => d.sumWeight * 6e-9,
                hexBinResolution: 3,
                hexTopColor: d => weightColor(d.sumWeight),
                hexSideColor: d => weightColor(d.sumWeight),
                hexBinMerge: true
            });

            fetch('worldpop.csv').then(res => res.text())
                .then(csv => d3.csvParse(csv, ({ lat, lng, pop }) => ({ lat: +lat, lng: +lng, pop: +pop })))
                .then(data => globeEntity.setAttribute('globe', 'hexBinPointsData', data));
        },
        /*

        popMap2() {
            const globeEntity = document.getElementById('globe2');
            globeEntity.setAttribute('globe', {
                heatmapPointLat: 'lat',
                heatmapPointLng: 'lng',
                heatmapPointWeight: 'pop',
                heatmapBandwidth: 0.9,
                heatmapColorSaturation: 2.8
            });

            fetch('worldpop.csv').then(res => res.text())
                .then(csv => d3.csvParse(csv, ({ lat, lng, pop }) => ({ lat: +lat, lng: +lng, pop: +pop })))
                .then(data => globeEntity.setAttribute('globe', 'heatmapsData', data));
        },*/

        /*  async setupScene() {
              try {
                  if (WebGPU.isAvailable() === false) {
                      document.body.appendChild(WebGPU.getErrorMessage());
                      throw new Error('No WebGPU support');
                  } else {
                      const sceneEl = this.$refs.scene;

                      // Create a WebGPURenderer instance and set it as the renderer for the scene
                      const webGPURenderer = new WebGPURenderer({ antialias: true });
                      sceneEl.renderer = webGPURenderer;

                      // Initialize other parts of your A-Frame scene as needed
                      this.loadEnvironmentComponent();
                      this.generateStars();

                      sceneEl.addEventListener('loaded', () => {
                          this.sceneEl = sceneEl;

                          // Initialize and configure post-processing effects
                          this.setupPostProcessing();
                      });

                      setInterval(this.updateRtc, 1000); // Update rotation every 10 milliseconds
                  }
              } catch (error) {
                  console.error(error);
              }
          },*/

        setupPostProcessing() {
            // Wait for the A-Frame scene to load
            this.$refs.scene.addEventListener('loaded', () => {
                const sceneEl = this.$refs.scene;
                const renderer = sceneEl.renderer;
                const camera = this.$refs.camera.getObject3D('camera');

                // Create the composer and configure post-processing passes
                const composer = new EffectComposer(renderer);

                // Add and configure post-processing passes
                const renderPass = new RenderPass(sceneEl.object3D, camera);
                composer.addPass(renderPass);

                // ... rest of your post-processing setup
                // Create and add the BloomEffect
                const bloomEffect = new BloomEffect({
                    blendFunction: BlendFunction.SCREEN,
                    luminanceThreshold: 0.8,
                    luminanceSmoothing: 0.075,
                    intensity: 1.0,
                    distinction: 3.0,
                });
                composer.addPass(bloomEffect);

                // Create and add the DepthOfFieldEffect
                const dofEffect = new DepthOfFieldEffect(camera, {
                    focusDistance: 0.1,
                    focalLength: 0.1,
                    bokehScale: 2.0,
                    height: 480, // Adjust the height as needed
                });
                composer.addPass(dofEffect);

                // Create and add the FXAAEffect
                const fxaaEffect = new FXAAEffect();
                composer.addPass(fxaaEffect);
                // Store the original render function
                const originalRender = renderer.render;

                // Set up a custom render function
                renderer.render = () => {
                    if (composer) {
                        // Call the original render method
                        originalRender.apply(renderer, arguments);
                        // Render the post-processing effects
                        composer.render();
                    } else {
                        // Handle the case where composer is not yet initialized
                        originalRender.apply(renderer, arguments);
                    }
                };

                console.log('Post Processing Setup Complete');
            });
        },
        initEffectComposer() {
            const sceneEl = this.sceneEl;

            if (!sceneEl.hasLoaded) {
                return;
            }

            const scene = sceneEl.object3D;
            const renderer = sceneEl.renderer;
            const camera = sceneEl.camera;

            const composer = new EffectComposer(renderer);
            const pass1 = new RenderPass(scene, camera);
            const pass2 = new BloomEffect(3, 25, 5, 256);
            const pass3 = new NoiseEffect();

            pass3.renderToScreen = true;

            composer.addPass(pass1);
            composer.addPass(pass2);
            composer.addPass(pass3);

            this.composer = composer;
            this.t = 0;
            this.dt = 0;

            this.bind();
        },

        /**
         * Record the timestamp for the current frame.
         * @param {number} t
         * @param {number} dt
         */
        tick: function(t, dt) {
            this.t = t;
            this.dt = dt;
        },
        bind() {
            const renderer = this.sceneEl.renderer;
            const system = this;
            let isDigest = false;

            const originalRender = renderer.render; // Store the original render method

            renderer.render = function() {
                if (system.composer) {
                    if (isDigest) {
                        originalRender.apply(this, arguments); // Call the original render method
                    } else {
                        isDigest = true;
                        system.composer.render(system.dt);
                        isDigest = false;
                    }
                } else {
                    // Handle the case where composer is not yet initialized
                    originalRender.apply(this, arguments);
                }
            };
        },
        getCanvas() {
            document.querySelector('a-scene').components.screenshot.getCanvas('equirectangular');

        },

        capture() {
            document.querySelector('a-scene').components.screenshot.capture('perspective')

        },

        preloadMarkerRemoval(index) {
            this.selectedIndex = index;
            console.log(index + " Selected")
        },
        handleMarkerRemoval() {
            // Create a new array without the marker at the specified index
            const index2 = this.selectedIndex;
            this.markerPositions = this.markerPositions.filter((_, i) => i !== index2);
            this.playChirp(index2 * 5 + 100, 0.1, 0.05);

            // Handle any other necessary updates
            console.log(`Marker at index ${index2} removed.`);
            this.selectedIndex = null;

        },
        onMarkerMouseEnter(title, description, link, index) {
            this.markerHovered = true;
            const raycaster = this.$refs.raycaster;
            const intersection = raycaster.components.raycaster.intersections[0];

            if (intersection) {
                const endPosition = intersection.point;
                const rayLine = this.$refs.rayLine;
                rayLine.setAttribute("line", `start: 0 0 0; end: ${endPosition.x} ${endPosition.y} ${endPosition.z}; color: white`);
                rayLine.setAttribute("visible", true);
            }

            this.markerTooltip.title = title;
            this.markerTooltip.description = description;
            this.markerTooltip.link = link;
            this.markerTooltip.visible = true;
            this.selectedMarkerIndex = index; // Set the selected marker index
        },
        onMarkerMouseLeave() {
            this.markerHovered = false;
            this.selectedMarkerIndex = -1; // Reset the selected marker index

            this.$refs.rayLine.setAttribute("visible", false);
        },

        updateRtc() {
            const currentTimeUTC = new Date().toUTCString().toUpperCase();
            this.currentTime = currentTimeUTC;
        },
        handleLatitudeLongitude({ lat, lon }) {
            console.log(`Received latitude: ${lat.toFixed(2)}, longitude: ${lon.toFixed(2)}`);
            this.latReceived = lat.toFixed(2);
            this.lonReceived = lon.toFixed(2);
            // Do whatever you need to do with the received latitude and longitude values
        },
        handleTitleDescLink({ title, desc, link }) {
            console.log(`Received Title: ${title}, Desc: ${desc}, Link: ${link}`);
            this.titleReceived = title;
            this.descReceived = desc;
            this.linkReceived = link;
            // Do whatever you need to do with the received latitude and longitude values
        },
        playChirp(freq, time, volume = 1) {
            if (this.muted !== true) {
                const duration = time;
                const frequency = freq;

                const oscillator = this.audioContext.createOscillator();
                oscillator.type = 'square';
                oscillator.frequency.setValueAtTime(frequency, this.audioContext.currentTime);

                const gainNode = this.audioContext.createGain();
                gainNode.gain.setValueAtTime(volume, this.audioContext.currentTime);

                oscillator.connect(gainNode);
                gainNode.connect(this.audioContext.destination);

                oscillator.start();
                oscillator.stop(this.audioContext.currentTime + duration);
            }
        },
        addMarker() {
            if (this.latReceived !== null && this.lonReceived !== null) {
                this.titleReceived = this.keyboardOutputTitle;
                this.descReceived = this.keyboardOutputDesc;
                this.linkReceived = this.keyboardOutputLink;
                const newMarker = {
                    lat: parseFloat(this.latReceived),
                    lon: parseFloat(this.lonReceived),
                    title: this.titleReceived, // Set a default title
                    description: this.descReceived,
                    link: this.linkReceived,
                };
                this.playChirp(newMarker.lat * 20 + 400, 0.05, 0.05);
                this.playChirp(newMarker.lon * 20 + 400, 0.05, 0.05);
                this.markerPositions.push(newMarker);

                // Clear the input values
                this.latInput = null;
                this.lonInput = null;
                this.latReceived = null;
                this.lonReceived = null;
                this.titleReceived = null;
                this.descReceived = null;
                this.linkReceived = null;


            }


        },
        handleDragging(newValue) {
            if (newValue > this.lastValue) {
                this.processMovement('down');
            } else if (newValue < this.lastValue) {
                this.processMovement('up');
            }
            this.lastValue = newValue;
        },
        handleMouseMove(event) {
            const centerX = window.innerWidth / 2;
            const deviationX = event.clientX - centerX;

            // Scale increases as the mouse moves closer to the center
            this.scale = 1 - Math.abs(deviationX) / centerX;

            // Rotation based on the position of the mouse from the center
            const rotationY = (deviationX / centerX) * 90; // Adjust 90 as per your needs for max rotation

            // Convert rotationY to an array format
            this.cursorrotationAngleY = [0, 0, rotationY];

            this.rotateCursorOuter();
        },
        rotateCursorOuter() {
            const rotC = this.cursorrotationAngleY[2]; // Access the third element for the Y rotation

            this.cursorOuterRotation = { x: 0, y: 0, z: rotC };
        },
        updateCameraPosition(newZ) {
            this.cameraPosition.z = newZ; // Update the cameraPosition data property
            const camera = this.$refs.camera;
            if (camera) {
                camera.setAttribute('position', `0 0 ${newZ}`);
            }
        },
        generateStars() {
            const numStars = 0;

            for (let i = 0; i < numStars; i++) {
                const position = `${this.getRandomPosition()} ${this.getRandomPosition()} ${this.getRandomPosition()}`;
                const radius = Math.random() * 0.005;

                this.stars.push({
                    position,
                    radius,
                });
            }
        },
        updateCoordinates(intersectionData) {
            this.latInput = intersectionData.lat;
            this.lonInput = intersectionData.lon;
        },
        getRandomPosition() {
            return (Math.random() - 0.5) * 50;
        },
        screenshot() {
            document.querySelector('a-scene').components.screenshot.capture('equirectangular');
        },

        async connectWallet() {
            console.log(this.wallet.addresses.NOCLIP)
            await this.wallet.connectWallet();
            this.noclip_balance = await this.wallet.contractMethod(this.wallet.addresses.NOCLIP, 'balanceOf', [this.wallet.address, ], ["uint"])
            this.ethers_balance = this.wallet.balance
            let totalSupply = await this.wallet.contractMethod(this.wallet.addresses.NOCLIP, 'totalSupply', [], ["uint"])
            let MAX_SUPPLY = await this.wallet.contractMethod(this.wallet.addresses.NOCLIP, 'MAX_SUPPLY', [], ["uint"])
            this.mintable_noclip = MAX_SUPPLY.sub(totalSupply)
            this.wallet.contractOn(this.wallet.addresses.NOCLIP, IERC20.abi, 'Transfer', async (from, to, amount) => {
                if (to == this.wallet.address) {
                    this.noclip_balance = this.wallet.contractMethod(this.wallet.addresses.NOCLIP, 'balanceOf', [this.wallet.address, ], ["uint"])
                    let totalSupply = await this.wallet.contractMethod(this.wallet.addresses.NOCLIP, 'totalSupply', [], ["uint"])
                    let MAX_SUPPLY = await this.wallet.contractMethod(this.wallet.addresses.NOCLIP, 'MAX_SUPPLY', [], ["uint"])
                    this.mintable_noclip = MAX_SUPPLY.sub(totalSupply)
                    console.log(amount)
                }
            })
        },
        async buyNoclip() {
            let amount = ethers.utils.parseEther(this.amount.toString())
            this.metamask_error = null
            if (amount < 1 * 1e14) {
                amount = "0.0001"
                this.amount = "0.0001"
            }
            this.loading = true
            try {
                const transaction = await this.wallet.sendEther(this.wallet.addresses.NOCLIP, this.amount.toString())
                console.log(transaction)
                this.amount = null
            } catch (e) {
                console.log(e)

            } finally {
                this.loading = false
            }

        }

    },
    computed: {
        ethersBalance() {
            //convert ethers_balance from big number to a float with only 2 decimal places
            let balance = ethers.utils.formatEther(this.ethers_balance)
            return parseFloat(balance).toFixed(2)

        },
        noclipBalance() {
            let balance = ethers.utils.formatEther(this.noclip_balance)
            return parseFloat(balance).toFixed(0)
        },
        mintableNoclip() {
            let balance = ethers.utils.formatEther(this.mintable_noclip)
            return parseFloat(balance).toFixed(0)
        },
    },
    watch: {
        look(newVal, oldVal) {
            const cameraEl = this.$refs.camera;

            if (newVal !== oldVal) {
                if (newVal) {
                    // Enable look-controls
                    cameraEl.setAttribute('look-controls', 'enabled', true);
                } else {
                    // Disable look-controls
                    cameraEl.setAttribute('look-controls', 'enabled', false);
                }
            }
        },
        wheelcount(newValue, oldValue) {


            if (newValue > oldValue) {
                this.processMovement('down');
            } else if (newValue < oldValue) {
                this.processMovement('up');
            }
            this.lastValue = newValue;
            if (newValue === 50) {

                setTimeout(() => this.introRender(true), 5);


            }
            if (newValue === 120) {

                setTimeout(() => this.animateText('STREAM AUGMENTATION LAYERS', this.$refs.noclipConstruction, 1, 2), 5);
                this.hud = 1;

            }
            if (newValue > 110 && newValue < 130) {

                this.hud = 1;

            } else { this.hud = 0; }
        },

        'cameraPosition.z': {
            immediate: true, // Trigger the handler immediately
            handler(newZ) {
                // Update the camera's position
                this.updateCameraPosition(newZ);
            },
        },

    },
    components: { "vue3-slider": slider, AFrameIcosahedralGlobe, ArcEntity, ArcEntityDeg, EtherAddress },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Oswald&family=Space+Mono:wght@400;700&display=swap');
@font-face {
    font-family: 'uno';
    src: url(../assets/unoestado.ttf);
}

.debug-wrapper {
    padding: 20px;
    width: 230px;
    user-select: none;
}

.menuHidden {
    pointer-events: none;
    opacity: 0;
    transition: all 0.2s ease;
}

.raycastable {
    cursor: pointer;
}

.cursor-pointer {
    cursor: pointer;
}

* {
    line-height: 1;
    scrollbar-width: none;
}

@keyframes fadeinblur {
    0% {
        backdrop-filter: blur(0px)invert(0)brightness(1)saturate(0)contrast(1.2);
    }
    80% {
        backdrop-filter: blur(0px)invert(0)brightness(1)saturate(0)contrast(1.2);
    }
    100% {
        backdrop-filter: blur(0px)invert(0)brightness(1)saturate(0)contrast(1);
    }
}

*::-webkit-scrollbar {
    width: 0px;
    /* width of the entire scrollbar */
}

.title {
    position: absolute;
    line-height: 1;
    left: 0px;
    color: #fffa;
    font-size: 10.2vh;
    bottom: 0px;
    height: calc(var(--vh, 1vh) * 100);
    width: 10vh;
    display: flex;
    flex-flow: column;
    border-radius: 2px;
    z-index: 10;
    justify-content: center;
    h1 {
        margin: auto;
        transform: rotate(-90deg) translatey(12vh) translatex(-45vh);
        transform-origin: left;
    }
}

.arrow {
    img {
        display: none;
    }
}

.row-buttons {
    perspective: 600px;
    display: flex;
    flex-flow: row;
    margin-bottom: 0.5rem;
    gap: 0rem !important;
    z-index: 20;
    position: relative;
    .overlays {
        border-left: 0px solid white;
        &:nth-child(1) {
            border-left: 2px solid white;
            border-right: 2px solid white;
        }
    }
}

.overlays {
    width: 100%;
    background: #3333;
    color: rgb(255, 255, 255);
    padding: 1rem;
    display: flex;
    transition: all 0.2s ease;
    flex-flow: row;
    border: 2px solid white;
    p {
        margin: unset;
        font-weight: 100;
        letter-spacing: calc((0.1vw + 0.1vh) / 2);
        font-size: calc((1.5vw + 1.5vh) / 2) !important;
    }
    img {
        width: calc((1.5vw + 1.5vh) / 2) !important;
        margin-left: auto;
        transition: all 0.2s ease;
        transform: rotate(-45deg) translate(calc(((1vw + 1vh) / 2)));
    }
    &:hover {
        background: white;
        color: black;
        img {
            filter: invert(1);
            transform: rotate(-45deg) translate(calc(((1.5vw + 1.5vh) / 2)));
        }
        .button-arrow {
            margin-right: 12px;
            &:before {
                background: #fffa;
            }
            &:after {
                background: #fffa;
            }
        }
    }
    .button-arrow {
        position: relative;
        transform: rotate(-45deg);
        margin: auto;
        margin-right: 1rem;
        margin-top: 21px;
        transition: all 0.2s ease;
        &:before {
            content: '';
            width: 20px;
            height: 3px;
            background: black;
            position: absolute;
            transition: all 0.2s ease;
        }
        &:after {
            content: '';
            width: 20px;
            height: 3px;
            background: black;
            position: absolute;
            transform-origin: top right;
            transition: all 0.2s ease;
            transform: rotate(90deg)translatex(3px);
        }
    }
}

html.a-fullscreen .a-canvas {
    height: calc(var(--vh, 1vh) * 100) !important;
}

.title-stack {
    margin: calc(50vh - 16vh - 3rem) auto auto;
    width: fit-content;
    max-width: 100%;
}

.exists {
    display: block !important;
}

.existsflex {
    display: flex !important;
}

.top-menu-add {
    display: flex;
    flex-flow: row;
}

.company-buttonrow {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    width: 200px;
    .companybutton {
        color: black;
        padding: 0.6rem;
        background: #fffa;
    }
}

.arrownav {
    filter: saturate(0);
}

.intro-guide {
    display: none;
    user-select: none;
    position: absolute;
    margin-bottom: -50vh;
    width: 250px;
    height: 50px;
    left: calc(50vw - 125px);
}

@keyframes orbit {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.noclip {
    margin: 11px;
    width: 30px;
    height: 30px;
    border: 2px solid white;
    border-radius: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    &:after {
        content: '';
        position: absolute;
        width: 24px;
        transform-origin: left;
        height: 2px;
        border-right: 2px solid #fffa;
        animation: orbit 5s linear infinite;
        left: 45px;
    }
    p {
        font-size: 0.5rem;
        text-align: center;
    }
}

.about-stack {
    display: flex;
    flex-flow: row;
    margin: auto;
    width: fit-content;
    max-width: 100%;
    .about-area-a {
        div {
            transition: all 0.2s ease;
            border-radius: 0px;
            display: flex;
            flex-flow: column;
            background: #0005;
            border: 2px solid white;
            height: calc(100% - 3rem - 4px);
            padding: 0.5rem;
            margin-top: 2rem;
            backdrop-filter: blur(5px);
            img {
                transition: all 0.2s ease;
                height: 64px;
                margin: auto;
                transform: rotate(90deg);
            }
        }
    }
    .about-area-b {
        .central-viewport {
            transition: all 0.2s ease;
            .overlays {
                width: calc(100% - 6rem);
                margin: auto;
            }
            .screen-constraint {
                position: relative;
                z-index: 5;
                width: calc(100% - 4rem);
                height: calc(100% - 4rem);
                margin: 2rem;
                transition: all 0.2s ease;
                .blurback-about {
                    box-shadow: 0px 0px 100px #0005;
                    margin: 1rem;
                    padding: 1rem;
                    border-radius: 0px;
                    border: 2px dashed #ffffff;
                    backdrop-filter: blur(10px);
                    height: calc(100% - 4rem - 6px);
                    background-color: #000a;
                    display: flex;
                    flex-flow: row;
                    transition: all 0.2s ease;
                    z-index: 2;
                    position: relative;
                    .text-area-about {
                        display: flex;
                        flex-flow: column;
                        justify-content: center;
                        margin-right: 1rem !important;
                        p {
                            user-select: none;
                        }
                        h1 {
                            user-select: none;
                        }
                    }
                    .image-wrapper {
                        display: flex;
                        flex-flow: column;
                        justify-content: center;
                        perspective: 1200px;
                        .image-backdrop {
                            perspective: 1200px;
                            margin: auto;
                            width: 350px;
                            height: 350px;
                            border-radius: 100%; //background: #0002;
                            //backdrop-filter: blur(10px);
                            //border: 10px solid #fffa;
                            display: flex;
                            flex-flow: wrap;
                            justify-content: Center;
                        }
                    }
                }
            }
        }
    }
}

@keyframes glowy {
    0% {
        color: #fffa;
    }
    50% {
        color: #888;
    }
    100% {
        color: #fffa;
    }
}

.mint-stack {
    display: flex;
    flex-flow: row-reverse;
    margin: auto;
    width: fit-content;
    max-width: 100%;
    .about-area-a {
        .readerbar {
            transition: all 0.2s ease;
            border-radius: 0px;
            display: flex;
            overflow: hidden;
            flex-flow: column;
            justify-content: flex-end;
            border: 2px solid white;
            height: calc(100% - 1rem - 4px);
            padding: 0px;
            margin-top: 0rem;
            backdrop-filter: blur(5px);
            .filler {
                transition: all 0.5s ease;
                background: #ffffff;
                width: 4rem;
                position: relative;
                bottom: 0px;
            }
            .filler-user {
                width: 100%;
                transform-origin: bottom;
                position: relative;
                background: white;
            }
            .filler-mobile {
                display: none;
            }
            .filler-user-mobile {
                display: none;
            }
        }
    }
    .about-area-b {
        .central-viewport {
            width: 564px;
            margin-top: unset !important;
            height: auto;
            transition: all 0.2s ease;
            .overlays {
                width: calc(100% - 6rem);
                margin: auto;
                &:hover {
                    p {
                        &:nth-child(1) {
                            color: white;
                        }
                    }
                }
            }
            .screen-constraint {
                position: relative;
                z-index: 5;
                width: calc(100% - 4rem);
                height: calc(100% - 4rem);
                margin: 2rem auto !important;
                margin-bottom: 1rem !important;
                transition: all 0.2s ease;
                .blurback-about {
                    box-shadow: 0px 0px 100px #0005;
                    margin: 1rem;
                    border: 2px dashed #fff;
                    padding: 1rem;
                    border-radius: 0px;
                    backdrop-filter: blur(10px);
                    height: calc(100% - 4rem - 6px);
                    background-color: #000a;
                    display: flex;
                    flex-flow: row;
                    transition: all 0.2s ease;
                    z-index: 2;
                    position: relative;
                    .text-area-about {
                        margin: 0rem;
                        display: flex;
                        flex-flow: column;
                        justify-content: center;
                        .mint-details {
                            padding: 1rem;
                            margin-top: 0rem;
                            margin-bottom: 0.5rem;
                            background-color: #181818;
                            border-radius: 0px;
                        }
                        .button-small {
                            border-radius: 0px;
                            display: flex;
                            flex-flow: column;
                            min-width: 90px;
                            height: 32px;
                            justify-content: center;
                            text-align: center;
                            font-weight: bold;
                            margin-top: 0.5rem;
                            margin-right: unset;
                            margin-left: 0.5rem;
                            &:hover {
                                .mint {
                                    color: black;
                                }
                            }
                            .mint {
                                animation: glowy 2s ease infinite;
                                color: #fffa;
                                text-shadow: 0px 0px 5px;
                            }
                            p {
                                margin: 0.5rem auto;
                                font-size: 1rem !important;
                            }
                        }
                    }
                    .image-wrapper {
                        display: flex;
                        flex-flow: column;
                        justify-content: center;
                        perspective: 1200px;
                        .image-backdrop {
                            perspective: 1200px;
                            margin: auto;
                            width: 350px;
                            height: 350px;
                            border-radius: 100%; //background: #0002;
                            //backdrop-filter: blur(10px);
                            //border: 10px solid #fffa;
                            display: flex;
                            flex-flow: wrap;
                            justify-content: Center;
                        }
                    }
                }
            }
        }
    }
}

.tx-info {
    display: flex;
    flex-flow: row;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 0px;
    margin-bottom: 0.5rem;
    background: black;
    p {
        &:nth-child(2) {
            text-align: right;
            border-left: 1px dashed white;
        }
        width:auto;
        line-height:1.5;
        margin:-0.25rem 0rem;
    }
}

.contract-info {
    display: flex;
    flex-flow: row;
    gap: 0.5rem;
    padding: 0.5rem;
    border-radius: 0px;
    background: #fffa;
}

.whitepaper {
    margin: unset;
    height: 100%;
    width: min-content;
    font-size: 1rem;
    margin-top: unset;
    text-align: center;
    border: 3px solid #333;
    background: #ffffff;
    padding: 1rem;
    border-radius: 0px;
    color: #333;
    transition: all 0.5s ease;
    &:hover {
        color: #fffa;
        background: #333;
    }
}

.contract {
    display: flex;
    flex-flow: column;
    justify-content: center;
    padding: unset;
    border-radius: 0px;
    width: 100%;
    background: #333;
}

a {
    text-decoration: unset !important;
    display: flex;
    width: fit-content;
}

.disclaimerOpen {
    height: auto !important;
}

.button-small {
    background: #ffffff;
    width: fit-content;
    border-radius: 0px;
    padding: 0.5rem 0.5rem;
    display: flex;
    flex-flow: row;
    transition: all 0.2s ease;
    text-decoration: unset !important;
    img {
        filter: invert(1);
    }
    &:hover {
        background: black;
        .mint {
            color: #fffa;
        }
        p {
            color: rgb(255, 255, 255)
        }
        img {
            filter: invert(0);
        }
    }
    p {
        transition: all 0.2s ease;
        margin: unset;
        color: rgb(0, 0, 0)
    }
    img {
        transition: all 0.2s ease;
        width: 1rem;
        margin-left: 2rem;
    }
}

.central-viewport {
    width: 1000px;
    height: 590px;
    position: relative;
    display: flex;
    flex-flow: column;
    .viewport-corners {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        &:before {
            content: '';
            top: 0px;
            position: absolute;
            left: 25%;
            width: 50%;
            height: 0.25rem;
            background: #ffffff;
        }
        &:after {
            content: '';
            bottom: 0px;
            position: absolute;
            left: 25%;
            width: 50%;
            height: 0.25rem;
            background: #ffffff;
        }
        .viewport-corner-1 {
            border: 0.25rem solid #ffffff;
            border-bottom: unset;
            border-right: unset;
            width: 50px;
            height: 50px;
            position: absolute;
            border-top-left-radius: 0.25rem;
        }
        .viewport-corner-2 {
            border: 0.25rem solid #ffffff;
            border-bottom: unset;
            border-left: unset;
            width: 50px;
            height: 50px;
            right: 0px;
            border-top-right-radius: 0.25rem;
            position: absolute;
        }
        .viewport-corner-3 {
            border: 0.25rem solid #ffffff;
            border-top: unset;
            border-right: unset;
            width: 50px;
            height: 50px;
            bottom: 0px;
            position: absolute;
            border-bottom-left-radius: 0.25rem;
        }
        .viewport-corner-4 {
            border: 0.25rem solid #ffffff;
            border-top: unset;
            border-left: unset;
            width: 50px;
            height: 50px;
            right: 0px;
            bottom: 0px;
            position: absolute;
            border-bottom-right-radius: 0.25rem;
        }
    }
}

@keyframes scrollguide {
    0% {
        transform: rotate(90deg)translatex(-20px);
        opacity: 0;
    }
    30% {
        transform: rotate(90deg)translatex(0px);
        opacity: 1;
    }
    60% {
        transform: rotate(90deg)translatex(20px);
        opacity: 0;
    }
    100% {
        transform: rotate(90deg)translatex(20px);
        opacity: 0;
    }
}

.vertical-raster-lines {
    position: absolute;
    height: 100%;
    top: 0;
    background-color: rgba(0, 0, 0, .05);
    width: 1px
}

.grid {
    position: fixed;
    top: 0;
    opacity: 1;
    height: calc(var(--vh, 1vh) * 100);
    pointer-events: none;
    z-index: 0;
    width: 100vw;
    left: 0;
    background: repeating-linear-gradient(180deg, transparent, transparent calc(4.16667vw - 1px), rgba(0, 0, 0, .05) calc(4.16667vw - 1px), rgba(0, 0, 0, .05) 4.166665vw);
}

.line-1 {
    left: 4.166665%
}

.line-2 {
    left: 8.33333%
}

.line-3 {
    left: 12.499995%
}

.line-4 {
    left: 16.66666%
}

.line-5 {
    left: 20.833325%
}

.line-6 {
    left: 24.99999%
}

.line-7 {
    left: 29.166655%
}

.line-8 {
    left: 33.33332%
}

.line-9 {
    left: 37.499985%
}

.line-10 {
    left: 41.66665%
}

.line-11 {
    left: 45.833315%
}

.line-12 {
    left: 49.99998%
}

.line-13 {
    left: 54.166645%
}

.line-14 {
    left: 58.33331%
}

.line-15 {
    left: 62.499975%
}

.line-16 {
    left: 66.66664%
}

.line-17 {
    left: 70.833305%
}

.line-18 {
    left: 74.99997%
}

.line-19 {
    left: 79.166635%
}

.line-20 {
    left: 83.3333%
}

.line-21 {
    left: 87.499965%
}

.line-22 {
    left: 91.66663%
}

.line-23 {
    left: 95.833295%
}

.intro-cover {
    z-index: 2;
    width: 100vw;
    position: fixed;
    left: 0px;
    top: 0px;
    height: calc(var(--vh, 1vh) * 100);
    animation: fadeinblur 2s ease 1;
    &:after {
        content: '';
        z-index: 1;
        width: 100vw;
        position: fixed;
        left: 0px;
        top: 0px;
        height: calc(var(--vh, 1vh) * 100); //background: radial-gradient(#0001, #fff5);
        animation: crtoutput 10ms infinite;
    }
    backdrop-filter: blur(0px)invert(0)brightness(0.5)saturate(0)contrast(1);
}

@keyframes crtoutput {
    0% {
        opacity: .85
    }
    to {
        opacity: .9
    }
}

.top-content {
    //background: linear-gradient(to bottom, #333, #3335, transparent);
}

.bottom-content {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    .bottom-left-section {
        margin: 1rem;
        padding: 1rem;
        position: relative;
        &::after {
            content: '';
            width: 2rem;
            height: 2px;
            position: absolute;
            bottom: 0px;
            left: 0px;
            background: white;
        }
        &::before {
            content: '';
            width: 2px;
            height: 2rem;
            position: absolute;
            bottom: 0px;
            left: 0px;
            background: white;
        }
    }
    z-index: 12;
    line-height: 1;
    width: auto;
    position: fixed;
    bottom: 0rem;
    padding: 1rem;
    left: 0rem;
    display: flex;
    flex-flow: column;
    gap: 0rem;
    justify-content: space-between; //background: linear-gradient(to top, #333, #3335, transparent, transparent);
}

.bottom-left-content {
    //border-top-right-radius: 1rem;
    position: relative; // border-right: 3px solid #fffa;
    // border-top: 3px solid #fffa;
    // box-shadow: inset 0px 0px 10px #0005;
    text-shadow: 0px 0px 5px black;
    opacity: 0.75;
    color: #ffff;
    p {
        font-size: 0.75rem;
        text-align: center;
        margin: unset;
        letter-spacing: 1px;
        font-weight: 100 !important;
        b {
            font-weight: 100 !important;
            display: none;
        }
    }
    /*  &:after {
        content: '';
        position: absolute;
        width: 70%;
        top: -3px;
        height: 3px;
        background: #fffa;
        border-radius: 1rem;
        left: 0px;
    }*/
}

.forward-arrow {
    width: 32px;
    height: 32px;
    position: relative;
    img {
        position: absolute;
        &:nth-child(2) {
            opacity: 0;
        }
        &:hover {
            &:nth-child(1) {
                opacity: 0;
            }
            &:nth-child(2) {
                opacity: 1;
            }
        }
    }
}

.back-arrow {
    width: 32px;
    height: 32px;
    position: relative;
    img {
        position: absolute;
        &:nth-child(2) {
            opacity: 0;
        }
        &:hover {
            &:nth-child(1) {
                opacity: 0;
            }
            &:nth-child(2) {
                opacity: 1;
            }
        }
    }
}

.bottom-center-content {
    // border-right: 3px solid #fffa;
    //border-top: 3px solid #fffa;
    // border-top-left-radius: 1rem;
    // border-top-right-radius: 1rem;
    position: relative; // border-left: 3px solid #fffa;
    //box-shadow: inset 0px 0px 10px #0005;  text-shadow: 0px 0px 5px black;
    opacity: 0.75;
    color: #ffff;
    p {
        text-align: center;
        letter-spacing: 1px;
        font-size: 0.75rem;
        margin: unset;
        font-weight: 100 !important;
        b {
            font-weight: 100 !important;
        }
    }
    /*  &:after {
        content: '';
        position: absolute;
        width: 80%;
        left: 10%;
        height: 3px;
        top: -3px;
        background: #fffa;
        border-radius: 1rem;
    }*/
}

.bottom-right-content {
    // border-top-left-radius: 1rem;
    position: relative; // border-left: 3px solid #fffa;
    // border-top: 3px solid #fffa;
    text-shadow: 0px 0px 5px black;
    opacity: 0.75;
    color: #ffff;
    p {
        text-align: center;
        letter-spacing: 1px;
        font-size: 0.75rem;
        margin: unset;
        font-weight: 100 !important;
        b {
            font-weight: 100 !important;
        }
    }
    /* &:after {
        content: '';
        position: absolute;
        width: 70%;
        height: 3px;
        top: -3px;
        background: #fffa;
        border-radius: 1rem;
        right: 0px;
    }*/
}

.black-block {
    position: relative;
    display: flex;
    align-self: bottom;
    height: 200px;
    width: 200px;
    margin-top: auto;
    background: black;
}

@keyframes fadein {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.social-diag {
    margin-bottom: auto;
    margin-top: 100px;
    .socialbutton {
        transform-origin: bottom right;
        transform: rotate(-45deg);
        background: black;
        width: calc(100% - 1.4rem);
        padding: 0.5rem 0.7rem;
        border-bottom-right-radius: 50px;
        border-top-right-radius: 50px;
        margin-bottom: 40px;
        border-left: 5px solid #fffa;
        p {
            margin: unset;
        }
    }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: opacity 0.5s, transform 0.5s;
}

.fade-scale-enter-from,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0);
}

.fade-scale-enter-to,
.fade-scale-leave-from {
    opacity: 1;
    transform: scale(1);
}

.inverted {
    filter: invert(0.8);
}

.row {
    margin-top: -8px;
    border-bottom: 1px solid #fffa;
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    p {
        font-size: 0.75rem;
    }
    input {
        font-size: 0.75rem !important;
        display: flex;
        justify-content: space-between;
        border-radius: 0px !important;
        margin-left: 8px;
        &:nth-child(3) {
            margin-left: 0px;
            margin-right: 8px;
            border-left: 1px solid #fffa;
            text-align: right;
        }
    }
}

.a-loader-title {
    display: none;
}

.ipaddress {
    margin: 1rem;
}

.title-top-data {
    user-select: none;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    text-shadow: 0px 0px 5px black;
    color: #fffd;
    font-size: calc((1vw + 1vh) / 2) !important;
}

.title-bottom-data {
    user-select: none;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    text-shadow: 0px 0px 5px black;
    color: #fffd;
    font-size: calc((1vw + 1vh) / 2) !important;
}

.title-middle-data {
    h1 {
        margin: unset;
        margin-left: -1vh;
        margin-top: -3.5vh;
        margin-right: 0.8vh;
        font-size: 20vh;
        color: #ffffff;
        letter-spacing: -2vh;
        text-align: center;
        perspective: 600px;
        margin-bottom: -1vh;
        span {
            user-select: none;
            text-shadow: 0px 0px 0px;
            transition: all 0.2s ease;
            &:active {
                color: white;
            }
            &:hover {
                text-shadow: 0px 0px 20px;
                transform: translatez(-5px) !important;
            }
        }
    }
}

.top-menu-corner {
    width: 100px;
    height: 50px;
    top: 0px;
    background: white;
    left: -120px;
    position: absolute;
    &:before {
        height: 50px;
        width: 100px;
        transform-origin: right top;
        content: '';
        transform: rotate(-45deg);
        background: white;
        position: absolute;
        left: -100px;
    }
}

.data-box {
    color: #ffffff;
    width: 200px;
    height: 200px;
    border: 2px solid #ffffff;
    display: flex;
    position: relative;
    flex-flow: wrap;
    min-width: 200px;
    .time {
        margin-top: 135px;
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        padding: 10px;
        border: 1px dotted #ffffff;
    }
    &:after {
        content: '';
        position: absolute;
        width: 180px;
        height: 115px;
        margin: 10px;
        margin-bottom: auto;
        background: repeating-linear-gradient( 45deg, #ffffff, #ffffff 10px, #ffffff00 10px, #ffffff00 20px);
    }
}

.address {
    .animation-container {
        span {
            font-family: 'Space Mono', monospace !important;
        }
    }
}

.orangeback {
    background: #fffa;
}

.data-box2 {
    color: #000000;
    width: 100%;
    height: auto;
    padding: 20px;
    display: flex;
    position: relative;
    backdrop-filter: blur(20px);
    background: #fff5;
    flex-flow: row-reverse;
    clip-path: polygon(calc(100% - 2rem) 0, 100% 2rem, 100% calc(100% - 2rem), calc(100% - 2rem) 100%, 0 100%, 0 0);
    .time {
        margin-top: 135px;
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        padding: 10px;
        border: 1px dotted #ffffff;
    }
    .passport {
        width: 100%;
        background: #333;
        height: 100%;
        color: white;
        clip-path: polygon(calc(100% - 1.4rem) 0, 100% 1.4rem, 100% calc(100% - 1.4rem), calc(100% - 1.4rem) 100%, 0 100%, 0 0);
        p {
            margin-top: unset;
            margin-bottom: unset;
            &:nth-child(1) {
                margin-top: 1rem;
            }
        }
    }
    p {
        margin: 20px;
        text-transform: uppercase;
    }
    button {
        height: 100%;
        width: 80px;
        margin-right: 20px;
        transition: all 0.2s ease;
        p {
            transition: all 0.2s ease;
            transform: rotate(-90deg)translatey(-20px);
            margin: unset;
            font-weight: bold;
            width: 100px;
            color: black;
            text-transform: uppercase;
        }
        border-radius: unset;
        background: unset;
        padding: 0.5rem 0.5rem;
        background:#fffa;
        border: 2px solid #e7b648 !important;
        &:hover {
            p {
                color: rgb(0, 0, 0)
            }
            ;
            background: transparent;
            border: 2px solid black !important;
        }
    }
}

.data-box-ip {
    color: #ffffff;
    width: 200px;
    height: 200px;
    border: 2px solid #ffffff;
    display: flex;
    flex-flow: wrap;
    min-width: 200px;
    position: relative;
    .ipaddress {
        margin-bottom: 135px;
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-top: 10px !important;
        padding: 10px;
        width: 100%;
        border: 1px dotted #ffffff;
        height: fit-content;
    }
    &:after {
        content: '';
        position: absolute;
        width: 180px;
        height: 135px;
        margin: 10px;
        top: 55px;
        margin-top: auto;
        background: repeating-linear-gradient( 45deg, #ffffff, #ffffff 10px, #ffffff00 10px, #ffffff00 20px);
    }
}

@keyframes bgroll {
    0% {
        background-position-x: 0px;
    }
    100% {
        background-position-x: 42px;
    }
}

@keyframes bgroll2 {
    0% {
        background-position-y: 0px;
    }
    100% {
        background-position-y: 42px;
    }
}

.left-complication {
    position: relative;
    display: none;
    margin-right: 30px;
    height: calc(var(--vh, 1vh) * 100);
    width: 200px;
    flex-flow: column;
    justify-content: flex-end;
}

.warning-back {
    overflow: hidden;
    &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        padding-top: 200px;
        margin-top: -200px;
        animation: bgroll2 0.5s linear infinite;
        background-image: repeating-linear-gradient( -45deg, #3332, #3332 15px, #ffffff00 15px, #ffffff00 30px);
    }
}

.warning-back-horizontal {
    overflow: hidden;
    &:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0px;
        padding-right: 200px;
        margin-right: -200px;
        animation: bgroll 0.5s linear infinite;
        background-image: repeating-linear-gradient( -45deg, #3335, #3335 15px, #ffffff00 15px, #ffffff00 30px);
    }
}

.warning-strip {
    display: flex;
    flex-flow: row;
    position: relative;
    height: auto;
    border-radius: 0px;
    width: calc(100% - 6px);
    height: 42px;
    overflow: hidden;
    transition: box-shadow 0.5s ease;
    border: 3px solid #333;
    &:after {
        content: '';
        padding-top: auto;
        width: calc(100% + 200px);
        padding-left: 200px;
        margin-left: -200px;
        position: absolute;
        backdrop-filter: blur(10px);
        background-color: #2225;
        height: 100%;
        left: 0px;
        border-radius: 0px;
        overflow: hidden;
        background-image: repeating-linear-gradient( -45deg, #3331, #3331 20px, #ffffff00 20px, #ffffff00 30px);
    }
    .warning-strip-filler {
        transition: right 0.5s ease;
        content: '';
        padding-top: auto;
        height: 100%;
        width: auto;
        padding-left: 200px;
        margin-left: -200px;
        left: 0px;
        overflow: hidden;
        z-index: 2;
        border-radius: 0px;
        position: absolute;
        animation: bgroll 1s linear infinite;
        background-image: repeating-linear-gradient( -45deg, #e7b648, #e7b648 20px, #ffffff00 20px, #ffffff00 30px);
    }
}

.complications {
    position: relative;
    width: auto;
    height: calc(var(--vh, 1vh) * 100);
    overflow: auto;
    right: 0px;
    display: flex;
    flex-flow: row;
    justify-content: center;
}

.top-menu-block {
    width: 100%;
    height: 100px;
    background: white;
    margin-bottom: 20px;
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 2rem), calc(100% - 2rem) 100%, calc(20% - 2rem) 100%, calc(20% - 5rem) 50%, 0 50%);
}

.bottom-menu-block {
    width: 50%;
    height: 50px;
    background: transparent;
    border: 2px solid #fffa;
    margin-top: auto;
    display: none;
    position: relative;
    border-bottom: unset;
    clip-path: polygon(2rem 0, calc(100% - 2rem) 0, 100% 2rem, 100% 100%, 0 100%, 0 2rem);
    &:before {
        content: "";
        width: 2.8rem;
        position: absolute;
        height: 2px;
        top: 0px;
        left: 0px;
        transform-origin: right center;
        transform: rotate(-45deg) translatex(-0.5rem) translatey(-0.7rem);
        background: #fffa;
    }
    &:after {
        content: "";
        width: 2.8rem;
        position: absolute;
        height: 2px;
        top: 0px;
        right: 0px;
        transform-origin: left center;
        transform: rotate(45deg) translatex(0.5rem) translatey(-0.7rem);
        background: #fffa;
    }
}

.cta-main-page {
    backdrop-filter: blur(10px);
    margin-top: 20px;
    padding: 20px;
    border-radius: 20px;
    border: 5px solid rgb(255, 255, 255);
}

.center-complication {
    width: 1000px;
    position: relative;
}

.menu-box {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    top: auto;
    right: 0px;
    position: relative;
    left: 202px;
    background: transparent;
    border-top: 2px solid rgb(255, 255, 255);
    width: 100%;
    margin-top: -2px;
}

.menubutton {
    height: 50px;
    width: 200px;
    border: 2px solid rgb(255, 255, 255);
    border-top: unset;
}

.mainUI {
    border: 0px solid pink;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    /* allow click-through in transparent areas */
    display: flex;
    align-items: center;
    justify-content: center;
}

.regionUI {
    border: 0px solid yellow;
    position: absolute;
    display: flex;
    flex-direction: row;
    pointer-events: none;
}

.buttonUI {
    z-index: 1000;
    border: 0px solid lime;
    display: flex;
    margin-top: 50vh;
    flex-direction: column;
    justify-content: center;
    pointer-events: auto;
    cursor: pointer;
    filter: drop-shadow(0px 0px 20px white);
}

.smallButton {
    font-size: 0.75rem;
    margin: unset;
    border: 1px solid #fffa;
    padding: 0rem 0.25rem;
    right: 0px;
    position: absolute;
    color: black;
    background: #fffa;
    border-radius: 2px;
    margin-top: 0.2rem;
    &:hover {
        color: black;
        background: #ee9900;
    }
}

.buttonrow {
    backdrop-filter: blur(10px);
    display: flex;
    flex-flow: row;
    width: 228px;
    overflow: hidden;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border: 1px solid #fffa;
    div {
        background: #fffa;
        width: 20px;
        height: 20px;
        display: flex;
        flex-flow: row;
        justify-content: center;
        border-left: 1px solid #00000022;
        transition: all 0-.2s ease;
        &:hover {
            background: #ee9900;
        }
        &:nth-child(1) {
            border: unset;
        }
    }
}

.debug-controls {
    position: fixed;
    right: 20px;
    top: 20px;
    z-index: 5;
    height: 52px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    width: 52px;
    .debug-wrapper {
        filter: blur(10px);
        transition: all 0.2s ease;
    }
}

.menuOpen {
    width: auto;
    right: 0px;
    top: 10px;
    height: auto;
    .debug-wrapper {
        filter: blur(0px);
        transition: all 0.02s ease;
    }
}

input {
    padding: 0.5rem 1rem;
    height: 2rem;
    font-family: 'Space Mono', monospace;
    font-size: 1rem;
    box-shadow: inset 0px 0px 10px #0005;
}

.spacemono {
    display: block ruby;
    font-family: "Space Mono", monospace !important;
    span {
        font-family: "Space Mono", monospace !important;
    }
}

.close {
    z-index: 2000;
    color: rgb(0, 0, 0);
    height: 20px;
    transition: all 0.2s ease;
    width: 20px;
    border-radius: 20px;
    position: relative;
    margin-left: auto;
    margin-right: 18px;
    margin-top: 8px;
    margin-bottom: -42px;
    right: 0px;
    font-family: "Space Mono", monospace;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: center;
    bottom: unset;
    background: #fffa;
    border: 1px solid #fffa;
    &:after {
        content: '+';
        transform: rotate(45deg);
        font-weight: bold;
        margin-top: -0.5px;
        margin-right: -0.5px;
    }
}

@keyframes pulse {
    0% {
        background: transparent !important;
    }
    50% {
        background: #e7b648 !important;
    }
    0% {
        background: transparent !important;
    }
}

.menuClose {
    border-radius: 30px;
    height: 50px;
    width: 50px;
    position: absolute !important;
    margin: unset !important;
    bottom: 0px !important;
    animation: pulse 2s ease infinite;
    color: rgb(255, 255, 255) !important;
    background: transparent !important;
    backdrop-filter: blur(10px);
    bottom: 0px !important;
    width: 50px;
    &:after {
        content: '+' !important;
        font-weight: bold;
        transform: rotate(720deg) !important;
        margin-top: -2px !important;
        font-size: 2rem;
    }
}

.a-loader-title {
    display: none !important;
}

.demo-desc {
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100);
    top: 0px;
    left: 0px;
    position: fixed;
    font-family: 'Space Mono', monospace;
    display: flex;
    flex-flow: column;
    justify-content: center;
    backdrop-filter: blur(10px)brightness(0.5);
    .infobox {
        p {
            user-select: none;
            margin-top: unset;
        }
        .button {
            cursor: pointer;
            user-select: none;
            padding: 1rem;
            background: white;
            color: rgb(109, 112, 126);
            &:hover {
                opacity: 0.5;
            }
        }
        max-width: calc(100vw - 4rem);
        position: relative;
        margin: auto;
        width: 600px;
        z-index: 1000;
        background: black;
        color: white;
        padding: 2rem;
        a {
            color: white;
        }
    }
}

#buttonEnter {
    transition: all 0.2s ease;
    opacity: 0.2;
    &:hover {
        opacity: 1;
    }
}

.marker-tooltip {
    position: fixed;
    top: 10px;
    left: 10px;
    background-color: rgba(255, 255, 255, 0.2);
    padding: 10px;
    border-radius: 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    h2 {
        margin: 0 0 5px;
        font-size: 18px;
        color: white;
    }
    p {
        margin: 0;
        color: white;
    }
    a {
        display: block;
        margin-top: 5px;
    }
}

h1 {}

p {
    font-family: 'Space Mono', monospace;
}

@keyframes spinsoc {
    0% {
        transform: rotate(360deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

.top-left-content {
    width: 58px;
    flex-flow: wrap;
    justify-content: center;
}

.top-right-content {
    .socials-wrapper {
        display: flex;
        flex-flow: row;
        justify-content: center;
        border-radius: 100%;
        margin: 10px;
        height: auto;
        position: relative;
        width: auto !important;
        border: 3px dashed transparent;
        transition: all 0.5s ease;
        padding: 0px 4px;
        &::after {
            content: '';
            width: 2rem;
            height: 2px;
            position: absolute;
            top: 0px;
            right: 0px;
            background: white;
        }
        &::before {
            content: '';
            width: 2px;
            height: 2rem;
            position: absolute;
            top: 0px;
            right: 0px;
            background: white;
        }
        .menu-strip {
            transition: all 0.5s ease;
            position: relative;
            transform-origin: right;
            width: 32px;
            height: 32px;
            display: flex;
            flex-flow: column;
            justify-content: center;
            opacity: 1;
            transition-delay: 5s;
            a {
                z-index: 1;
                height: 100%;
                width: 100%;
                display: flex;
                flex-flow: row;
                justify-content: center;
                position: absolute;
                margin: auto;
                img {
                    margin: auto !important;
                }
            }
        }
    }
}

.a-dialog-text {
    font-family: 'Space Mono', monospace !important;
    color: black !important;
}

.a-dialog-allow-button {
    font-family: 'Space Mono', monospace !important;
    color: black !important;
    background-color: white !important;
}

.a-dialog-button {
    font-family: 'Space Mono', monospace !important;
    color: black !important;
    border: 1px solid black !important;
}

.a-dialog-deny-button {
    font-family: 'Space Mono', monospace !important;
    color: white !important;
    background-color: black !important;
}

.segmentbutton {
    border: 0;
    bottom: 20px;
    cursor: pointer;
    min-width: 100px;
    background: white;
    display: none;
    flex-flow: column;
    justify-content: center;
    &:after {
        font-family: 'Space Mono', monospace;
        content: 'FILTER';
        color: black;
        position: absolute;
        text-align: center;
        width: 100%;
    }
    min-height: 34px;
    padding-right: 0;
    padding-top: 0;
    position: fixed;
    left: 20px;
    z-index: 9999;
    &:hover {
        filter: invert(1);
    }
}

.screenshot {
    border: 0;
    bottom: 20px;
    cursor: pointer;
    min-width: 120px;
    background: white;
    display: none;
    flex-flow: column;
    justify-content: center;
    &:after {
        font-family: 'Space Mono', monospace;
        content: 'SCREENSHOT';
        color: black;
        position: absolute;
        text-align: center;
        width: 100%;
    }
    min-height: 34px;
    padding-right: 0;
    padding-top: 0;
    position: fixed;
    left: 140px;
    z-index: 9999;
    &:hover {
        filter: invert(1);
    }
}

.perspective {
    perspective: 600px;
    height: calc(var(--vh, 1vh) * 100);
    width: 100vw;
    position: fixed;
    left: 0px;
    top: 0px;
    display: flex;
    flex-flow: column;
    z-index: -1;
    justify-content: center;
    .dot-grid {
        &:nth-child(1) {
            opacity: 0.75;
            .dot {
                transition: all 0.25s ease;
            }
        }
        &:nth-child(2) {
            opacity: 0.5;
            .dot {
                transition: all 0.2s ease;
            }
            transform: translateZ(-25px)
        }
        &:nth-child(3) {
            opacity: 0.25;
            .dot {
                transition: all 0.75s ease;
            }
            transform: translateZ(-50px)
        }
    }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.apparea {
    background: black;
    color: white;
    height: calc(var(--vh, 1vh) * 100);
    top: 0px;
    position: fixed;
    width: 100vw;
    display: flex;
    flex-flow: column;
    justify-content: center;
    .centered {
        width: 1024px;
        max-width: calc(100% - 4rem);
        display: flex;
        flex-flow: column;
        margin: auto;
        justify-content: center;
        .typer {
            margin: auto;
            padding-left: 0px;
        }
        h1 {
            margin: auto 0px;
            margin-right: 1rem;
            user-select: none;
            font-size: 2.9rem;
            padding-bottom: 0.4rem;
            width: fit-content;
            font-family: 'uno';
        }
        .line {
            margin-right: 1rem;
            border-radius: 4px;
            height: 2rem;
            margin: auto;
            background: white;
            width: 4rem;
            margin-right: 1rem;
            position: absolute;
            &::before {
                position: absolute;
                content: '';
                margin-right: 1rem;
                border-radius: 4px;
                height: 5rem;
                margin: auto;
                top: -5.5rem;
                background: white;
                width: 4rem;
                margin-right: 1rem;
            }
            &::after {
                position: absolute;
                content: '';
                margin-right: 1rem;
                border-radius: 4px;
                height: 3rem;
                margin: auto;
                bottom: -3.5rem;
                background: white;
                width: 4rem;
                margin-right: 1rem;
            }
        }
        .circ {
            position: absolute;
            width: 512px;
            left: calc(50% - 256px);
            transform: rotate(-90deg);
        }
    }
}

b {
    font-family: "Space Mono", monospace !important;
}

.socials {
    display: flex;
    justify-content: center;
    margin: 0;
    position: fixed;
    top: 20px;
    left: 20px;
    height: auto;
    min-height: 34px;
    gap: 0.5rem;
    padding: 0px 10px;
    background-color: white;
    z-index: 10;
    a {
        display: flex;
        flex-flow: column;
        justify-content: center;
        position: relative;
        transition: all 0.2s ease;
        transform-origin: 50% 50%;
        &:hover {
            transform: scale(1.2);
        }
    }
    img {
        height: 20px;
        transition: all 0.2s ease;
        &:nth-child(2) {
            position: absolute; //filter: blur(2px)brightness(2);
        }
    }
}

.rs-base {
    border: 1px solid #e7b648 !important;
    font-family: 'Space Mono', monospace !important;
    background: unset !important;
    backdrop-filter: blur(10px)brightness(0.5);
    border-radius: 4px !important;
    transform: scale(0.75);
    transform-origin: top left;
}

.rs-counter-base {}

.alarm {
    filter: hue-rotate(70deg)brightness(3.5) !important;
    text-shadow: unset !important;
}

.balance-info {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    margin-top: 0.5rem;
    .line {
        width: 100%;
        margin: auto 0.5rem;
        height: 1px;
        background: linear-gradient(to right, transparent, gray, transparent);
    }
    &:nth-child(1) {
        margin-top: unset;
    }
    p {
        &:nth-child(1) {
            width: -webkit-fill-available;
            width: -moz-available;
            max-width: fit-content;
        }
        margin: unset;
    }
}

@media screen and (max-height:800px) {
    p {
        flex-flow: column;
        justify-content: center;
    }
    .intro-guide {
        margin-bottom: -65vh;
        div {
            img {
                animation: 3s ease 0s infinite normal none running scrollguide;
                height: auto;
                width: 1rem !important;
                margin: 0px !important;
            }
        }
    }
    .overlays {
        p {
            font-size: 0.5rem;
        }
    }
    .mint-stack,
    .about-stack {
        p {
            line-height: 1 !important;
        }
        .about-area-a {
            display: none !important;
        }
    }
}

@media screen and (max-device-width: 812px) and (device-aspect-ratio: 9 / 19.5) {
    /* Specific styles for certain iOS devices */
}

@media screen and (max-width:100vh) {

    .overlays{min-width:calc(10vw + 1rem);}
    .top-right-content {
        .socials-wrapper {
            flex-flow: column;
            padding:4px 4px;
            .menu-strip {
                margin: unset;
            }
        }
    }
    .top-left-content {
        margin-left: -1rem;
    }
    .top-right-content {
        margin-right: -1rem !important;
    }
    .bottom-center-content {
        p {
            line-height: 0.5rem;
            font-size: 0.5rem;
        }
    }
    .bottom-left-content {
        p {
            text-align: left;
            line-height: 0.5rem;
            font-size: 0.5rem;
            b {
                display: block;
            }
        }
    }
    .bottom-right-content {
        p {
            text-align: right;
            font-size: 0.5rem;
            line-height: 0.5rem;
            b {
                display: none;
            }
        }
    }
    .bottom-content {
        margin: 0rem;
        padding: 0rem;
    }
    .noclip {
        margin: 11px;
        width: 30px;
        height: 30px;
        border: 2px solid white;
        display: flex;
        flex-flow: column;
        justify-content: center;
        &:after {
            content: '';
            position: absolute;
            width: 24px;
            transform-origin: left;
            height: 2px;border-radius:100%;
            border-right: 2px solid #fffa;
            animation: orbit 5s linear infinite;
            left: 45px;
            margin-left: -1rem;
        }
        p {
            font-size: 0.5rem;
            text-align: center;
            color: #fffa;
        }
    }
    .top-middle-content {
        display: flex;
        flex-flow: column !important;
        justify-content: center;
        opacity: 0.25;
        transition: all 0.5s ease;
        &:hover {
            opacity: 1;
        }
    }
    .top-content {
        padding-top: unset;
        padding-bottom: unset !important;
        padding-top: unset !important;
    }
    .top-right-content {
        transform-origin: top right;
        display: flex;
        flex-flow: column !important;
        justify-content: flex-start;
        transform: scale(1);
        margin-top: 0rem;
        max-height: 48px;
        margin-right: 0rem;
        p {
            margin: unset;
            margin-top: 0.5rem;
        }
    }
    .tx-info {
        p {
            width: -webkit-fill-available;
            width: -moz-available;
            &:nth-child(2) {
                padding-left: 0.5rem;
            }
        }
    }
    .balance-info {
        p {
            margin-bottom: unset !important;
        }
    }
    .contract-info {
        display: flex;
        flex-flow: column;
        gap: 0.5rem;
        .contract {
            padding: 0.5rem !important;
        }
    }
    .whitepaper {
        margin: unset;
        height: 100%;
        width: auto;
        font-size: 1rem;
        margin-top: unset;
        text-align: center;
        background: #ffffff;
        padding: 0.5rem;
        border-radius: 0px;
        color: rgb(0, 0, 0);
    }
    .contract {
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 1rem;
        border-radius: 0px;
        width: auto;
        background: black;
    }
    .row-buttons {
        flex-flow: row;
        .overlays {
            &:nth-child(1) {}
        }
    }
    .about-stack {
        display: flex;
        flex-flow: column;
        margin: auto;
        width: fit-content;
        max-width: 100%;
        transform: scale(1) !important;
        .about-area-a {
            div {
                display: flex;
                flex-flow: row;
                padding: 0rem;
                margin: auto;
                padding: calc(0.5rem - 5px);
                margin-bottom: 0rem;
                width: auto !important;
                height: auto;
                max-width: calc(100% - 4rem - 10px);
                border-radius: 0px;
                border: 5px solid #333;
                img {
                    height: 32px;
                    margin: auto;
                    transform: rotate(0deg);
                }
            }
        }
        .about-area-b {
            .central-viewport {
                display: flex;
                flex-flow: column;
                justify-content: center;
                width: 100vw;
                height: auto;
                .overlays {
                    margin: auto;
                    width: 100% !important;
                    margin-top: 1rem;
                    max-width: calc(100vw - 6rem);
                }
                .screen-constraint {
                    position: relative;
                    z-index: 5;
                    width: calc(100% - 4rem);
                    height: calc(100% - 4rem);
                    margin: auto;
                    margin-top: 0rem !important;
                    .blurback-about {
                        box-shadow: inset 0px 0px 100px #0005, 0px 0px 100px #0005;
                        margin: 1rem;
                        padding: 1rem;
                        border-radius: 4px;
                        backdrop-filter: blur(10px);
                        height: calc(100% - 4rem);
                        display: flex;
                        flex-flow: column;
                        .text-area-about {
                            margin-left: unset !important;
                            h1 {
                                font-size: 1rem;
                            }
                            a {
                                .button-small {
                                    p {
                                        margin: auto !important;
                                    }
                                }
                            }
                        }
                        .image-wrapper {
                            display: flex;
                            flex-flow: column;
                            justify-content: center;
                            perspective: 1200px;
                            .image-backdrop {
                                transform: scale(1) !important;
                                perspective: 1200px;
                                margin: auto;
                                width: 200px;
                                height: 150px;
                                border-radius: 100%; // background: #0002;
                                //backdrop-filter: blur(10px);
                                //border: 10px solid #fffa;
                                display: flex;
                                flex-flow: wrap;
                                justify-content: Center;
                                img {
                                    transform: scale(1) !important;
                                    width: 120px !important;
                                }
                                div {
                                    transform: scale(1) !important;
                                    height: 120px !important;
                                    width: 120px !important;
                                    img {
                                        border-radius: 20px;
                                        width: 80px !important;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .mint-stack {
        transform: scale(1) !important;
        display: flex;
        flex-flow: column-reverse;
        margin: auto;
        width: fit-content;
        max-width: 100%;
        .about-area-a {
            display: flex;
            flex-flow: row;
            justify-content: center;
            .readerbar {
                transition: all 0.2s ease;
                border: 5px solid #333;
                border-radius: 0px;
                display: flex;
                overflow: hidden;
                backdrop-filter: blur(5px);
                flex-flow: row;
                justify-content: flex-start;
                width: calc(100% - 4rem - 10px);
                padding: 0px;
                margin-top: 0rem;
                height: auto;
                .filler {
                    display: none;
                }
                .filler-user {
                    display: none;
                }
                .filler-mobile {
                    background: #fffa;
                    height: 38px;
                    position: relative;
                    left: 0px;
                    bottom: 0px;
                    display: block;
                }
                .filler-user-mobile {
                    background: white;
                    height: 38px;
                    position: relative;
                    bottom: 0px;
                    display: block;
                }
            }
        }
        .about-area-b {
            .central-viewport {
                width: auto;
                height: auto;
                transition: all 0.2s ease;
                .overlays {
                    width: calc(100% - 6rem);
                    margin: auto;
                    &:hover {
                        p {
                            &:nth-child(1) {
                                color: white;
                            }
                        }
                    }
                }
                .screen-constraint {
                    position: relative;
                    z-index: 5;
                    width: calc(100% - 4rem);
                    height: calc(100% - 4rem);
                    margin: 2rem;
                    margin-top: 1rem !important;
                    transition: all 0.2s ease;
                    .blurback-about {
                        h1 {
                            text-align: center;
                        }
                        box-shadow:inset 0px 0px 100px #0005,
                        0px 0px 100px #0005;
                        margin: 1rem;
                        padding: 0rem;
                        border-radius: 4px;
                        backdrop-filter: blur(10px);
                        height: calc(100% - 4rem);
                        background-color: #333a;
                        display: flex;
                        flex-flow: row;
                        transition: all 0.2s ease;
                        z-index: 2;
                        position: relative;
                        .text-area-about {
                            margin: 0rem;
                            width: 100%;
                            .mint-wrapper {
                                margin: 1rem;
                                .mint-details {
                                    padding: 1rem;
                                    margin-top: 0rem;
                                    text-align: center;
                                    margin-bottom: 0.5rem;
                                    background-color: #333;
                                    border-radius: 0px;
                                    p {
                                        margin: unset;
                                    }
                                }
                                .button-small {
                                    border-radius: 0px;
                                    display: flex;
                                    flex-flow: column;
                                    min-width: 90px;
                                    height: 32px;
                                    justify-content: center;
                                    text-align: center;
                                    font-weight: bold;
                                    margin-top: 0.5rem;
                                    margin-right: unset;
                                    margin-left: 0.5rem;
                                    p {
                                        margin: 0.5rem auto;
                                        font-size: 1rem !important;
                                    }
                                }
                            }
                        }
                        .image-wrapper {
                            display: flex;
                            flex-flow: column;
                            justify-content: center;
                            perspective: 1200px;
                            .image-backdrop {
                                perspective: 1200px;
                                margin: auto;
                                width: 350px;
                                height: 350px;
                                border-radius: 100%; //background: #0002;
                                //backdrop-filter: blur(10px);
                                //border: 10px solid #fffa;
                                display: flex;
                                flex-flow: wrap;
                                justify-content: Center;
                            }
                        }
                    }
                }
            }
        }
    }
    .disclaimerOpen {
        line-height: 0.5rem !important;
        height: auto !important;
    }
    .central-viewport {
        width: 1000px;
        height: 590px;
        position: relative;
        margin-top: 20px;
        display: flex;
        .viewport-corners {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0px;
            top: 0px;
            &:before {
                content: '';
                top: 0px;
                position: absolute;
                left: 25%;
                width: 50%;
                height: 0.25rem;
                background: #ffffff;
            }
            &:after {
                content: '';
                bottom: 0px;
                position: absolute;
                left: 25%;
                width: 50%;
                height: 0.25rem;
                background: #ffffff;
            }
            .viewport-corner-1 {
                border: 0.25rem solid #ffffff;
                border-bottom: unset;
                border-right: unset;
                width: 50px;
                height: 50px;
                position: absolute;
                border-top-left-radius: 0.25rem;
            }
            .viewport-corner-2 {
                border: 0.25rem solid #ffffff;
                border-bottom: unset;
                border-left: unset;
                width: 50px;
                height: 50px;
                right: 0px;
                border-top-right-radius: 0.25rem;
                position: absolute;
            }
            .viewport-corner-3 {
                border: 0.25rem solid #ffffff;
                border-top: unset;
                border-right: unset;
                width: 50px;
                height: 50px;
                bottom: 0px;
                position: absolute;
                border-bottom-left-radius: 0.25rem;
            }
            .viewport-corner-4 {
                border: 0.25rem solid #ffffff;
                border-top: unset;
                border-left: unset;
                width: 50px;
                height: 50px;
                right: 0px;
                bottom: 0px;
                position: absolute;
                border-bottom-right-radius: 0.25rem;
            }
        }
    }
    .warning-strip {
        display: flex;
        flex-flow: row;
        position: relative;
        border-radius: 0px;
        width: calc(100% - 6px);
        height: auto;
        min-height: 1rem;
        overflow: hidden;
        transition: box-shadow 0.5s ease;
        &:after {
            content: '';
            padding-top: auto;
            width: calc(100% + 200px);
            padding-left: 200px;
            margin-left: -200px;
            position: absolute;
            backdrop-filter: blur(10px);
            background-color: #2225;
            height: 100%;
            left: 0px;
            border-radius: 0px;
            overflow: hidden;
            background-image: repeating-linear-gradient( -45deg, #3335, #3335 20px, #ffffff00 20px, #ffffff00 30px);
        }
        .warning-strip-filler {
            transition: right 0.5s ease;
            content: '';
            animation: bgroll 1s linear infinite;
            padding-top: auto;
            height: 100%;
            width: auto;
            padding-left: 200px;
            margin-left: -200px;
            left: 0px;
            overflow: hidden;
            z-index: 2;
            border-radius: 0px;
            position: absolute;
            background-image: repeating-linear-gradient( -45deg, white, white 20px, #ffffff00 20px, #ffffff00 30px);
        }
    }
    h1 {
        font-size: 1rem;
    }
    .title-stack {
        transform: scale(1) !important;
        margin-top: 5vh;
        display: flex;
        flex-flow: column;
        position: relative;
    }
    p {
        line-height: 1rem;
        font-size: 0.5rem;
    }
    .title-top-data {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        text-shadow: 0px 0px 5px black;
        color: #fffd;
        position: absolute;
        bottom: unset;
        right: 0px;
        top: 50vh;
        transform: rotate(90deg);
        width: 50vh;
        transform-origin: right center;
        .arrow {
            width: 30% !important;
        }
        p {
            line-height: 1rem;
            font-size: 0.5rem;
        }
    }
    .title-bottom-data {
        display: flex;
        flex-flow: row;
        position: absolute;
        justify-content: space-between;
        font-size: 0.5rem;
        line-height: 1rem;
        text-shadow: 0px 0px 5px black;
        color: #fffd;
        width: 50vh;
        transform: rotate(90deg);
        transform-origin: left center;
        p {
            line-height: 1rem;
            font-size: 0.5rem;
        }
    }
    .title-middle-data {
        margin-bottom: 8vw;
        h1 {
            margin-top: -4vw;
            margin-right: 1vw;
            margin-bottom: unset;
            margin-left: -1.4vw;
            font-size: 18vw;
            color: #ffffff;
            letter-spacing: -2.5vw;
            text-align: center;
            display: flex;
            flex-flow: column;
            span {
                height: 16vw;
            }
        }
    }
    .mainUI {
        display: none !important;
    }
    .rs-base {
        transform-origin: top left;
        transform: scale(0.3);
        position: fixed !important;
        left: 20px !important;
        backdrop-filter: blur(10px);
        background: unset !important;
    }
    .debug-controls {
        transform: scale(1);
        transform-origin: top right;
        bottom: unset !important;
        top: 20px;
    }
    .menuOpen {
        bottom: unset !important;
        top: 10px !important;
    }
    .intro-guide {
        margin-bottom:-70vh;
        div {
            img {
                height: 25px !important;
                width: 25px !important;
            }
        }
    }
}
</style>
